var items = {
  "block.minecraft.acacia_button": "Tombol Akasia",
  "block.minecraft.acacia_door": "Pintu Akasia",
  "block.minecraft.acacia_fence": "Pagar Akasia",
  "block.minecraft.acacia_fence_gate": "Pintu Pagar Akasia",
  "block.minecraft.acacia_hanging_sign": "Papan Tanda Gantung Akasia",
  "block.minecraft.acacia_leaves": "Daun Akasia",
  "block.minecraft.acacia_log": "Gelondong Akasia",
  "block.minecraft.acacia_planks": "Papan Akasia",
  "block.minecraft.acacia_pressure_plate": "Pelat Penekan Akasia",
  "block.minecraft.acacia_sapling": "Bibit Akasia",
  "block.minecraft.acacia_shelf": "Rak Akasia",
  "block.minecraft.acacia_sign": "Papan Tanda Akasia",
  "block.minecraft.acacia_slab": "Lempeng Akasia",
  "block.minecraft.acacia_stairs": "Tangga Akasia",
  "block.minecraft.acacia_trapdoor": "Pintu Kolong Akasia",
  "block.minecraft.acacia_wall_hanging_sign": "Papan Tanda Gantung Dinding Akasia",
  "block.minecraft.acacia_wall_sign": "Papan Tanda Dinding Akasia",
  "block.minecraft.acacia_wood": "Kayu Akasia",
  "block.minecraft.activator_rail": "Rel Pengaktif",
  "block.minecraft.air": "Udara",
  "block.minecraft.allium": "Bunga Bawang",
  "block.minecraft.amethyst_block": "Balok Kecubung",
  "block.minecraft.amethyst_cluster": "Gugus Kecubung",
  "block.minecraft.ancient_debris": "Puing Purba",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Lempeng Andesit",
  "block.minecraft.andesite_stairs": "Tangga Andesit",
  "block.minecraft.andesite_wall": "Tembok Andesit",
  "block.minecraft.anvil": "Paron",
  "block.minecraft.attached_melon_stem": "Batang Semangka Tertempel",
  "block.minecraft.attached_pumpkin_stem": "Batang Labu Tertempel",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Daun Azalea",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Balok Bambu",
  "block.minecraft.bamboo_button": "Tombol Bambu",
  "block.minecraft.bamboo_door": "Pintu Bambu",
  "block.minecraft.bamboo_fence": "Pagar Bambu",
  "block.minecraft.bamboo_fence_gate": "Pintu Pagar Bambu",
  "block.minecraft.bamboo_hanging_sign": "Papan Tanda Gantung Bambu",
  "block.minecraft.bamboo_mosaic": "Anyaman Bambu",
  "block.minecraft.bamboo_mosaic_slab": "Lempeng Anyaman Bambu",
  "block.minecraft.bamboo_mosaic_stairs": "Tangga Anyaman Bambu",
  "block.minecraft.bamboo_planks": "Papan Bambu",
  "block.minecraft.bamboo_pressure_plate": "Pelat Penekan Bambu",
  "block.minecraft.bamboo_sapling": "Rebung",
  "block.minecraft.bamboo_shelf": "Rak Bambu",
  "block.minecraft.bamboo_sign": "Papan Tanda Bambu",
  "block.minecraft.bamboo_slab": "Lempeng Bambu",
  "block.minecraft.bamboo_stairs": "Tangga Bambu",
  "block.minecraft.bamboo_trapdoor": "Pintu Kolong Bambu",
  "block.minecraft.bamboo_wall_hanging_sign": "Papan Tanda Gantung Dinding Bambu",
  "block.minecraft.bamboo_wall_sign": "Papan Tanda Gantung Bambu",
  "block.minecraft.banner.base.black": "Muka Hitam",
  "block.minecraft.banner.base.blue": "Muka Biru",
  "block.minecraft.banner.base.brown": "Muka Cokelat",
  "block.minecraft.banner.base.cyan": "Muka Sian",
  "block.minecraft.banner.base.gray": "Muka Abu-Abu",
  "block.minecraft.banner.base.green": "Muka Hijau",
  "block.minecraft.banner.base.light_blue": "Muka Biru Muda",
  "block.minecraft.banner.base.light_gray": "Muka Abu-Abu Muda",
  "block.minecraft.banner.base.lime": "Muka Hijau Pupus",
  "block.minecraft.banner.base.magenta": "Muka Magenta",
  "block.minecraft.banner.base.orange": "Muka Jingga",
  "block.minecraft.banner.base.pink": "Muka Merah Muda",
  "block.minecraft.banner.base.purple": "Muka Ungu",
  "block.minecraft.banner.base.red": "Muka Merah",
  "block.minecraft.banner.base.white": "Muka Putih",
  "block.minecraft.banner.base.yellow": "Muka Kuning",
  "block.minecraft.banner.border.black": "Tepi Hitam",
  "block.minecraft.banner.border.blue": "Tepi Biru",
  "block.minecraft.banner.border.brown": "Tepi Cokelat",
  "block.minecraft.banner.border.cyan": "Tepi Sian",
  "block.minecraft.banner.border.gray": "Tepi Abu-Abu",
  "block.minecraft.banner.border.green": "Tepi Hijau",
  "block.minecraft.banner.border.light_blue": "Tepi Biru Muda",
  "block.minecraft.banner.border.light_gray": "Tepi Abu-Abu Muda",
  "block.minecraft.banner.border.lime": "Tepi Hijau Pupus",
  "block.minecraft.banner.border.magenta": "Tepi Magenta",
  "block.minecraft.banner.border.orange": "Tepi Jingga",
  "block.minecraft.banner.border.pink": "Tepi Merah Muda",
  "block.minecraft.banner.border.purple": "Tepi Ungu",
  "block.minecraft.banner.border.red": "Tepi Merah",
  "block.minecraft.banner.border.white": "Tepi Putih",
  "block.minecraft.banner.border.yellow": "Tepi Kuning",
  "block.minecraft.banner.bricks.black": "Bataan Hitam",
  "block.minecraft.banner.bricks.blue": "Bataan Biru",
  "block.minecraft.banner.bricks.brown": "Bataan Cokelat",
  "block.minecraft.banner.bricks.cyan": "Bataan Sian",
  "block.minecraft.banner.bricks.gray": "Bataan Abu-Abu",
  "block.minecraft.banner.bricks.green": "Bataan Hijau",
  "block.minecraft.banner.bricks.light_blue": "Bataan Biru Muda",
  "block.minecraft.banner.bricks.light_gray": "Bataan Abu-Abu Muda",
  "block.minecraft.banner.bricks.lime": "Bataan Hijau Pupus",
  "block.minecraft.banner.bricks.magenta": "Bataan Magenta",
  "block.minecraft.banner.bricks.orange": "Bataan Jingga",
  "block.minecraft.banner.bricks.pink": "Bataan Merah Muda",
  "block.minecraft.banner.bricks.purple": "Bataan Ungu",
  "block.minecraft.banner.bricks.red": "Bataan Merah",
  "block.minecraft.banner.bricks.white": "Bataan Putih",
  "block.minecraft.banner.bricks.yellow": "Bataan Kuning",
  "block.minecraft.banner.circle.black": "Bundar Hitam",
  "block.minecraft.banner.circle.blue": "Bundar Biru",
  "block.minecraft.banner.circle.brown": "Bundar Cokelat",
  "block.minecraft.banner.circle.cyan": "Bundar Sian",
  "block.minecraft.banner.circle.gray": "Bundar Abu-Abu",
  "block.minecraft.banner.circle.green": "Bundar Hijau",
  "block.minecraft.banner.circle.light_blue": "Bundar Biru Muda",
  "block.minecraft.banner.circle.light_gray": "Bundar Abu-Abu Muda",
  "block.minecraft.banner.circle.lime": "Bundar Hijau Pupus",
  "block.minecraft.banner.circle.magenta": "Bundar Magenta",
  "block.minecraft.banner.circle.orange": "Bundar Jingga",
  "block.minecraft.banner.circle.pink": "Bundar Merah Muda",
  "block.minecraft.banner.circle.purple": "Bundar Ungu",
  "block.minecraft.banner.circle.red": "Bundar Merah",
  "block.minecraft.banner.circle.white": "Bundar Putih",
  "block.minecraft.banner.circle.yellow": "Bundar Kuning",
  "block.minecraft.banner.creeper.black": "Rupa Creeper Hitam",
  "block.minecraft.banner.creeper.blue": "Rupa Creeper Biru",
  "block.minecraft.banner.creeper.brown": "Rupa Creeper Cokelat",
  "block.minecraft.banner.creeper.cyan": "Rupa Creeper Sian",
  "block.minecraft.banner.creeper.gray": "Rupa Creeper Abu-Abu",
  "block.minecraft.banner.creeper.green": "Rupa Creeper Hijau",
  "block.minecraft.banner.creeper.light_blue": "Rupa Creeper Biru Muda",
  "block.minecraft.banner.creeper.light_gray": "Rupa Creeper Abu-Abu Muda",
  "block.minecraft.banner.creeper.lime": "Rupa Creeper Hijau Pupus",
  "block.minecraft.banner.creeper.magenta": "Rupa Creeper Magenta",
  "block.minecraft.banner.creeper.orange": "Rupa Creeper Jingga",
  "block.minecraft.banner.creeper.pink": "Rupa Creeper Merah Muda",
  "block.minecraft.banner.creeper.purple": "Rupa Creeper Ungu",
  "block.minecraft.banner.creeper.red": "Rupa Creeper Merah",
  "block.minecraft.banner.creeper.white": "Rupa Creeper Putih",
  "block.minecraft.banner.creeper.yellow": "Rupa Creeper Kuning",
  "block.minecraft.banner.cross.black": "Silang Hitam",
  "block.minecraft.banner.cross.blue": "Silang Biru",
  "block.minecraft.banner.cross.brown": "Silang Cokelat",
  "block.minecraft.banner.cross.cyan": "Silang Sian",
  "block.minecraft.banner.cross.gray": "Silang Abu-Abu",
  "block.minecraft.banner.cross.green": "Silang Hijau",
  "block.minecraft.banner.cross.light_blue": "Silang Biru Muda",
  "block.minecraft.banner.cross.light_gray": "Silang Abu-Abu Muda",
  "block.minecraft.banner.cross.lime": "Silang Hijau Pupus",
  "block.minecraft.banner.cross.magenta": "Silang Magenta",
  "block.minecraft.banner.cross.orange": "Silang Jingga",
  "block.minecraft.banner.cross.pink": "Silang Merah Muda",
  "block.minecraft.banner.cross.purple": "Silang Ungu",
  "block.minecraft.banner.cross.red": "Silang Merah",
  "block.minecraft.banner.cross.white": "Silang Putih",
  "block.minecraft.banner.cross.yellow": "Silang Kuning",
  "block.minecraft.banner.curly_border.black": "Tepi Bertakik Hitam",
  "block.minecraft.banner.curly_border.blue": "Tepi Bertakik Biru",
  "block.minecraft.banner.curly_border.brown": "Tepi Bertakik Cokelat",
  "block.minecraft.banner.curly_border.cyan": "Tepi Bertakik Sian",
  "block.minecraft.banner.curly_border.gray": "Tepi Bertakik Abu-Abu",
  "block.minecraft.banner.curly_border.green": "Tepi Bertakik Hijau",
  "block.minecraft.banner.curly_border.light_blue": "Tepi Bertakik Biru Muda",
  "block.minecraft.banner.curly_border.light_gray": "Tepi Bertakik Abu-Abu Muda",
  "block.minecraft.banner.curly_border.lime": "Tepi Bertakik Hijau Pupus",
  "block.minecraft.banner.curly_border.magenta": "Tepi Bertakik Magenta",
  "block.minecraft.banner.curly_border.orange": "Tepi Bertakik Jingga",
  "block.minecraft.banner.curly_border.pink": "Tepi Bertakik Merah Muda",
  "block.minecraft.banner.curly_border.purple": "Tepi Bertakik Ungu",
  "block.minecraft.banner.curly_border.red": "Tepi Bertakik Merah",
  "block.minecraft.banner.curly_border.white": "Tepi Bertakik Putih",
  "block.minecraft.banner.curly_border.yellow": "Tepi Bertakik Kuning",
  "block.minecraft.banner.diagonal_left.black": "Paruh Serong Kidal Hitam",
  "block.minecraft.banner.diagonal_left.blue": "Paruh Serong Kidal Biru",
  "block.minecraft.banner.diagonal_left.brown": "Paruh Serong Kidal Cokelat",
  "block.minecraft.banner.diagonal_left.cyan": "Paruh Serong Kidal Sian",
  "block.minecraft.banner.diagonal_left.gray": "Paruh Serong Kidal Abu-Abu",
  "block.minecraft.banner.diagonal_left.green": "Paruh Serong Kidal Hijau",
  "block.minecraft.banner.diagonal_left.light_blue": "Paruh Serong Kidal Biru Muda",
  "block.minecraft.banner.diagonal_left.light_gray": "Paruh Serong Kidal Abu-Abu Muda",
  "block.minecraft.banner.diagonal_left.lime": "Paruh Serong Kidal Hijau Pupus",
  "block.minecraft.banner.diagonal_left.magenta": "Paruh Serong Kidal Magenta",
  "block.minecraft.banner.diagonal_left.orange": "Paruh Serong Kidal Jingga",
  "block.minecraft.banner.diagonal_left.pink": "Paruh Serong Kidal Merah Muda",
  "block.minecraft.banner.diagonal_left.purple": "Paruh Serong Kidal Ungu",
  "block.minecraft.banner.diagonal_left.red": "Paruh Serong Kidal Merah",
  "block.minecraft.banner.diagonal_left.white": "Paruh Serong Kidal Putih",
  "block.minecraft.banner.diagonal_left.yellow": "Paruh Serong Kidal Kuning",
  "block.minecraft.banner.diagonal_right.black": "Paruh Serong Hitam",
  "block.minecraft.banner.diagonal_right.blue": "Paruh Serong Biru",
  "block.minecraft.banner.diagonal_right.brown": "Paruh Serong Cokelat",
  "block.minecraft.banner.diagonal_right.cyan": "Paruh Serong Sian",
  "block.minecraft.banner.diagonal_right.gray": "Paruh Serong Abu-Abu",
  "block.minecraft.banner.diagonal_right.green": "Paruh Serong Hijau",
  "block.minecraft.banner.diagonal_right.light_blue": "Paruh Serong Biru Muda",
  "block.minecraft.banner.diagonal_right.light_gray": "Paruh Serong Abu-Abu Muda",
  "block.minecraft.banner.diagonal_right.lime": "Paruh Serong Hijau Pupus",
  "block.minecraft.banner.diagonal_right.magenta": "Paruh Serong Magenta",
  "block.minecraft.banner.diagonal_right.orange": "Paruh Serong Jingga",
  "block.minecraft.banner.diagonal_right.pink": "Paruh Serong Merah Muda",
  "block.minecraft.banner.diagonal_right.purple": "Paruh Serong Ungu",
  "block.minecraft.banner.diagonal_right.red": "Paruh Serong Merah",
  "block.minecraft.banner.diagonal_right.white": "Paruh Serong Putih",
  "block.minecraft.banner.diagonal_right.yellow": "Paruh Serong Kuning",
  "block.minecraft.banner.diagonal_up_left.black": "Paruh Serong Sungsang Hitam",
  "block.minecraft.banner.diagonal_up_left.blue": "Paruh Serong Sungsang Biru",
  "block.minecraft.banner.diagonal_up_left.brown": "Paruh Serong Sungsang Cokelat",
  "block.minecraft.banner.diagonal_up_left.cyan": "Paruh Serong Sungsang Sian",
  "block.minecraft.banner.diagonal_up_left.gray": "Paruh Serong Sungsang Abu-Abu",
  "block.minecraft.banner.diagonal_up_left.green": "Paruh Serong Sungsang Hijau",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Paruh Serong Sungsang Biru Muda",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Paruh Serong Sungsang Abu-Abu Muda",
  "block.minecraft.banner.diagonal_up_left.lime": "Paruh Serong Sungsang Hijau Pupus",
  "block.minecraft.banner.diagonal_up_left.magenta": "Paruh Serong Sungsang Magenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Paruh Serong Sungsang Jingga",
  "block.minecraft.banner.diagonal_up_left.pink": "Paruh Serong Sungsang Merah Muda",
  "block.minecraft.banner.diagonal_up_left.purple": "Paruh Serong Sungsang Ungu",
  "block.minecraft.banner.diagonal_up_left.red": "Paruh Serong Sungsang Merah",
  "block.minecraft.banner.diagonal_up_left.white": "Paruh Serong Sungsang Putih",
  "block.minecraft.banner.diagonal_up_left.yellow": "Paruh Serong Sungsang Kuning",
  "block.minecraft.banner.diagonal_up_right.black": "Paruh Serong Kidal Sungsang Hitam",
  "block.minecraft.banner.diagonal_up_right.blue": "Paruh Serong Kidal Sungsang Biru",
  "block.minecraft.banner.diagonal_up_right.brown": "Paruh Serong Kidal Sungsang Cokelat",
  "block.minecraft.banner.diagonal_up_right.cyan": "Paruh Serong Kidal Sungsang Sian",
  "block.minecraft.banner.diagonal_up_right.gray": "Paruh Serong Kidal Sungsang Abu-Abu",
  "block.minecraft.banner.diagonal_up_right.green": "Paruh Serong Kidal Sungsang Hijau",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Paruh Serong Kidal Sungsang Biru Muda",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Paruh Serong Kidal Sungsang Abu-Abu Muda",
  "block.minecraft.banner.diagonal_up_right.lime": "Paruh Serong Kidal Sungsang Hijau Pupus",
  "block.minecraft.banner.diagonal_up_right.magenta": "Paruh Serong Kidal Sungsang Magenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Paruh Serong Kidal Sungsang Jingga",
  "block.minecraft.banner.diagonal_up_right.pink": "Paruh Serong Kidal Sungsang Merah Muda",
  "block.minecraft.banner.diagonal_up_right.purple": "Paruh Serong Kidal Sungsang Ungu",
  "block.minecraft.banner.diagonal_up_right.red": "Paruh Serong Kidal Sungsang Merah",
  "block.minecraft.banner.diagonal_up_right.white": "Paruh Serong Kidal Sungsang Putih",
  "block.minecraft.banner.diagonal_up_right.yellow": "Paruh Serong Kidal Sungsang Kuning",
  "block.minecraft.banner.flow.black": "Pilin Hitam",
  "block.minecraft.banner.flow.blue": "Pilin Biru",
  "block.minecraft.banner.flow.brown": "Pilin Cokelat",
  "block.minecraft.banner.flow.cyan": "Pilin Sian",
  "block.minecraft.banner.flow.gray": "Pilin Abu-Abu",
  "block.minecraft.banner.flow.green": "Pilin Hijau",
  "block.minecraft.banner.flow.light_blue": "Pilin Biru Muda",
  "block.minecraft.banner.flow.light_gray": "Pilin Abu-Abu Muda",
  "block.minecraft.banner.flow.lime": "Pilin Hijau Pupus",
  "block.minecraft.banner.flow.magenta": "Pilin Magenta",
  "block.minecraft.banner.flow.orange": "Pilin Jingga",
  "block.minecraft.banner.flow.pink": "Pilin Merah Muda",
  "block.minecraft.banner.flow.purple": "Pilin Ungu",
  "block.minecraft.banner.flow.red": "Pilin Merah",
  "block.minecraft.banner.flow.white": "Pilin Putih",
  "block.minecraft.banner.flow.yellow": "Pilin Kuning",
  "block.minecraft.banner.flower.black": "Rupa Bunga Hitam",
  "block.minecraft.banner.flower.blue": "Rupa Bunga Biru",
  "block.minecraft.banner.flower.brown": "Rupa Bunga Cokelat",
  "block.minecraft.banner.flower.cyan": "Rupa Bunga Sian",
  "block.minecraft.banner.flower.gray": "Rupa Bunga Abu-Abu",
  "block.minecraft.banner.flower.green": "Rupa Bunga Hijau",
  "block.minecraft.banner.flower.light_blue": "Rupa Bunga Biru Muda",
  "block.minecraft.banner.flower.light_gray": "Rupa Bunga Abu-Abu Muda",
  "block.minecraft.banner.flower.lime": "Rupa Bunga Hijau Pupus",
  "block.minecraft.banner.flower.magenta": "Rupa Bunga Magenta",
  "block.minecraft.banner.flower.orange": "Rupa Bunga Jingga",
  "block.minecraft.banner.flower.pink": "Rupa Bunga Merah Muda",
  "block.minecraft.banner.flower.purple": "Rupa Bunga Ungu",
  "block.minecraft.banner.flower.red": "Rupa Bunga Merah",
  "block.minecraft.banner.flower.white": "Rupa Bunga Putih",
  "block.minecraft.banner.flower.yellow": "Rupa Bunga Kuning",
  "block.minecraft.banner.globe.black": "Globe Hitam",
  "block.minecraft.banner.globe.blue": "Globe Biru",
  "block.minecraft.banner.globe.brown": "Globe Cokelat",
  "block.minecraft.banner.globe.cyan": "Globe Sian",
  "block.minecraft.banner.globe.gray": "Globe Abu-Abu",
  "block.minecraft.banner.globe.green": "Globe Hijau",
  "block.minecraft.banner.globe.light_blue": "Globe Biru Muda",
  "block.minecraft.banner.globe.light_gray": "Globe Abu-Abu Muda",
  "block.minecraft.banner.globe.lime": "Globe Hijau Pupus",
  "block.minecraft.banner.globe.magenta": "Globe Magenta",
  "block.minecraft.banner.globe.orange": "Globe Jingga",
  "block.minecraft.banner.globe.pink": "Globe Merah Muda",
  "block.minecraft.banner.globe.purple": "Globe Ungu",
  "block.minecraft.banner.globe.red": "Globe Merah",
  "block.minecraft.banner.globe.white": "Globe Putih",
  "block.minecraft.banner.globe.yellow": "Globe Kuning",
  "block.minecraft.banner.gradient.black": "Gradasi Hitam",
  "block.minecraft.banner.gradient.blue": "Gradasi Biru",
  "block.minecraft.banner.gradient.brown": "Gradasi Cokelat",
  "block.minecraft.banner.gradient.cyan": "Gradasi Sian",
  "block.minecraft.banner.gradient.gray": "Gradasi Abu-Abu",
  "block.minecraft.banner.gradient.green": "Gradasi Hijau",
  "block.minecraft.banner.gradient.light_blue": "Gradasi Biru Muda",
  "block.minecraft.banner.gradient.light_gray": "Gradasi Abu-Abu Muda",
  "block.minecraft.banner.gradient.lime": "Gradasi Hijau Pupus",
  "block.minecraft.banner.gradient.magenta": "Gradasi Magenta",
  "block.minecraft.banner.gradient.orange": "Gradasi Jingga",
  "block.minecraft.banner.gradient.pink": "Gradasi Merah Muda",
  "block.minecraft.banner.gradient.purple": "Gradasi Ungu",
  "block.minecraft.banner.gradient.red": "Gradasi Merah",
  "block.minecraft.banner.gradient.white": "Gradasi Putih",
  "block.minecraft.banner.gradient.yellow": "Gradasi Kuning",
  "block.minecraft.banner.gradient_up.black": "Gradasi Dasar Hitam",
  "block.minecraft.banner.gradient_up.blue": "Gradasi Dasar Biru",
  "block.minecraft.banner.gradient_up.brown": "Gradasi Dasar Cokelat",
  "block.minecraft.banner.gradient_up.cyan": "Gradasi Dasar Sian",
  "block.minecraft.banner.gradient_up.gray": "Gradasi Dasar Abu-Abu",
  "block.minecraft.banner.gradient_up.green": "Gradasi Dasar Hijau",
  "block.minecraft.banner.gradient_up.light_blue": "Gradasi Dasar Biru Muda",
  "block.minecraft.banner.gradient_up.light_gray": "Gradasi Dasar Abu-Abu Muda",
  "block.minecraft.banner.gradient_up.lime": "Gradasi Dasar Hijau Pupus",
  "block.minecraft.banner.gradient_up.magenta": "Gradasi Dasar Magenta",
  "block.minecraft.banner.gradient_up.orange": "Gradasi Dasar Jingga",
  "block.minecraft.banner.gradient_up.pink": "Gradasi Dasar Merah Muda",
  "block.minecraft.banner.gradient_up.purple": "Gradasi Dasar Ungu",
  "block.minecraft.banner.gradient_up.red": "Gradasi Dasar Merah",
  "block.minecraft.banner.gradient_up.white": "Gradasi Dasar Putih",
  "block.minecraft.banner.gradient_up.yellow": "Gradasi Dasar Kuning",
  "block.minecraft.banner.guster.black": "Prahara Hitam",
  "block.minecraft.banner.guster.blue": "Prahara Biru",
  "block.minecraft.banner.guster.brown": "Prahara Cokelat",
  "block.minecraft.banner.guster.cyan": "Prahara Sian",
  "block.minecraft.banner.guster.gray": "Prahara Abu-Abu",
  "block.minecraft.banner.guster.green": "Prahara Hijau",
  "block.minecraft.banner.guster.light_blue": "Prahara Biru Muda",
  "block.minecraft.banner.guster.light_gray": "Prahara Abu-Abu Muda",
  "block.minecraft.banner.guster.lime": "Prahara Hijau Pupus",
  "block.minecraft.banner.guster.magenta": "Prahara Magenta",
  "block.minecraft.banner.guster.orange": "Prahara Jingga",
  "block.minecraft.banner.guster.pink": "Prahara Merah Muda",
  "block.minecraft.banner.guster.purple": "Prahara Ungu",
  "block.minecraft.banner.guster.red": "Prahara Merah",
  "block.minecraft.banner.guster.white": "Prahara Putih",
  "block.minecraft.banner.guster.yellow": "Prahara Kuning",
  "block.minecraft.banner.half_horizontal.black": "Paruh Lintang Hitam",
  "block.minecraft.banner.half_horizontal.blue": "Paruh Lintang Biru",
  "block.minecraft.banner.half_horizontal.brown": "Paruh Lintang Cokelat",
  "block.minecraft.banner.half_horizontal.cyan": "Paruh Lintang Sian",
  "block.minecraft.banner.half_horizontal.gray": "Paruh Lintang Abu-Abu",
  "block.minecraft.banner.half_horizontal.green": "Paruh Lintang Hijau",
  "block.minecraft.banner.half_horizontal.light_blue": "Paruh Lintang Biru Muda",
  "block.minecraft.banner.half_horizontal.light_gray": "Paruh Lintang Abu-Abu Muda",
  "block.minecraft.banner.half_horizontal.lime": "Paruh Lintang Hijau Pupus",
  "block.minecraft.banner.half_horizontal.magenta": "Paruh Lintang Magenta",
  "block.minecraft.banner.half_horizontal.orange": "Paruh Lintang Jingga",
  "block.minecraft.banner.half_horizontal.pink": "Paruh Lintang Merah Muda",
  "block.minecraft.banner.half_horizontal.purple": "Paruh Lintang Ungu",
  "block.minecraft.banner.half_horizontal.red": "Paruh Lintang Merah",
  "block.minecraft.banner.half_horizontal.white": "Paruh Lintang Putih",
  "block.minecraft.banner.half_horizontal.yellow": "Paruh Lintang Kuning",
  "block.minecraft.banner.half_horizontal_bottom.black": "Paruh Lintang Sungsang Hitam",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Paruh Lintang Sungsang Biru",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Paruh Lintang Sungsang Cokelat",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Paruh Lintang Sungsang Sian",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Paruh Lintang Sungsang Abu-Abu",
  "block.minecraft.banner.half_horizontal_bottom.green": "Paruh Lintang Sungsang Hijau",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Paruh Lintang Sungsang Biru Muda",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Paruh Lintang Sungsang Abu-Abu Muda",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Paruh Lintang Sungsang Hijau Pupus",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Paruh Lintang Sungsang Magenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Paruh Lintang Sungsang Jingga",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Paruh Lintang Sungsang Merah Muda",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Paruh Lintang Sungsang Terbalik Ungu",
  "block.minecraft.banner.half_horizontal_bottom.red": "Paruh Lintang Sungsang Merah",
  "block.minecraft.banner.half_horizontal_bottom.white": "Paruh Lintang Sungsang Putih",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Paruh Lintang Sungsang Kuning",
  "block.minecraft.banner.half_vertical.black": "Paruh Bujur Hitam",
  "block.minecraft.banner.half_vertical.blue": "Paruh Bujur Biru",
  "block.minecraft.banner.half_vertical.brown": "Paruh Bujur Cokelat",
  "block.minecraft.banner.half_vertical.cyan": "Paruh Bujur Sian",
  "block.minecraft.banner.half_vertical.gray": "Paruh Bujur Abu-Abu",
  "block.minecraft.banner.half_vertical.green": "Paruh Bujur Hijau",
  "block.minecraft.banner.half_vertical.light_blue": "Paruh Bujur Biru Muda",
  "block.minecraft.banner.half_vertical.light_gray": "Paruh Bujur Abu-Abu Muda",
  "block.minecraft.banner.half_vertical.lime": "Paruh Bujur Hijau Pupus",
  "block.minecraft.banner.half_vertical.magenta": "Paruh Bujur Magenta",
  "block.minecraft.banner.half_vertical.orange": "Paruh Bujur Jingga",
  "block.minecraft.banner.half_vertical.pink": "Paruh Bujur Merah Muda",
  "block.minecraft.banner.half_vertical.purple": "Paruh Bujur Ungu",
  "block.minecraft.banner.half_vertical.red": "Paruh Bujur Merah",
  "block.minecraft.banner.half_vertical.white": "Paruh Bujur Putih",
  "block.minecraft.banner.half_vertical.yellow": "Paruh Bujur Kuning",
  "block.minecraft.banner.half_vertical_right.black": "Paruh Bujur Sungsang Hitam",
  "block.minecraft.banner.half_vertical_right.blue": "Paruh Bujur Sungsang Biru",
  "block.minecraft.banner.half_vertical_right.brown": "Paruh Bujur Sungsang Cokelat",
  "block.minecraft.banner.half_vertical_right.cyan": "Paruh Bujur Sungsang Sian",
  "block.minecraft.banner.half_vertical_right.gray": "Paruh Bujur Sungsang Abu-Abu",
  "block.minecraft.banner.half_vertical_right.green": "Paruh Bujur Sungsang Hijau",
  "block.minecraft.banner.half_vertical_right.light_blue": "Paruh Bujur Sungsang Biru Muda",
  "block.minecraft.banner.half_vertical_right.light_gray": "Paruh Bujur Sungsang Abu-Abu Muda",
  "block.minecraft.banner.half_vertical_right.lime": "Paruh Bujur Sungsang Hijau Pupus",
  "block.minecraft.banner.half_vertical_right.magenta": "Paruh Bujur Sungsang Magenta",
  "block.minecraft.banner.half_vertical_right.orange": "Paruh Bujur Sungsang Jingga",
  "block.minecraft.banner.half_vertical_right.pink": "Paruh Bujur Sungsang Merah Muda",
  "block.minecraft.banner.half_vertical_right.purple": "Paruh Bujur Sungsang Ungu",
  "block.minecraft.banner.half_vertical_right.red": "Paruh Bujur Sungsang Merah",
  "block.minecraft.banner.half_vertical_right.white": "Paruh Bujur Sungsang Putih",
  "block.minecraft.banner.half_vertical_right.yellow": "Paruh Bujur Sungsang Kuning",
  "block.minecraft.banner.mojang.black": "Lambang Hitam",
  "block.minecraft.banner.mojang.blue": "Lambang Biru",
  "block.minecraft.banner.mojang.brown": "Lambang Cokelat",
  "block.minecraft.banner.mojang.cyan": "Lambang Sian",
  "block.minecraft.banner.mojang.gray": "Lambang Abu-Abu",
  "block.minecraft.banner.mojang.green": "Lambang Hijau",
  "block.minecraft.banner.mojang.light_blue": "Lambang Biru Muda",
  "block.minecraft.banner.mojang.light_gray": "Lambang Abu-Abu Muda",
  "block.minecraft.banner.mojang.lime": "Lambang Hijau Pupus",
  "block.minecraft.banner.mojang.magenta": "Lambang Magenta",
  "block.minecraft.banner.mojang.orange": "Lambang Jingga",
  "block.minecraft.banner.mojang.pink": "Lambang Merah Muda",
  "block.minecraft.banner.mojang.purple": "Lambang Ungu",
  "block.minecraft.banner.mojang.red": "Lambang Merah",
  "block.minecraft.banner.mojang.white": "Lambang Putih",
  "block.minecraft.banner.mojang.yellow": "Lambang Kuning",
  "block.minecraft.banner.piglin.black": "Moncong Hitam",
  "block.minecraft.banner.piglin.blue": "Moncong Biru",
  "block.minecraft.banner.piglin.brown": "Moncong Cokelat",
  "block.minecraft.banner.piglin.cyan": "Moncong Sian",
  "block.minecraft.banner.piglin.gray": "Moncong Abu-Abu",
  "block.minecraft.banner.piglin.green": "Moncong Hijau",
  "block.minecraft.banner.piglin.light_blue": "Moncong Biru Muda",
  "block.minecraft.banner.piglin.light_gray": "Moncong Abu-Abu Muda",
  "block.minecraft.banner.piglin.lime": "Moncong Hijau Pupus",
  "block.minecraft.banner.piglin.magenta": "Moncong Magenta",
  "block.minecraft.banner.piglin.orange": "Moncong Jingga",
  "block.minecraft.banner.piglin.pink": "Moncong Merah Muda",
  "block.minecraft.banner.piglin.purple": "Moncong Ungu",
  "block.minecraft.banner.piglin.red": "Moncong Merah",
  "block.minecraft.banner.piglin.white": "Moncong Putih",
  "block.minecraft.banner.piglin.yellow": "Moncong Kuning",
  "block.minecraft.banner.rhombus.black": "Wajik Hitam",
  "block.minecraft.banner.rhombus.blue": "Wajik Biru",
  "block.minecraft.banner.rhombus.brown": "Wajik Cokelat",
  "block.minecraft.banner.rhombus.cyan": "Wajik Sian",
  "block.minecraft.banner.rhombus.gray": "Wajik Abu-Abu",
  "block.minecraft.banner.rhombus.green": "Wajik Hijau",
  "block.minecraft.banner.rhombus.light_blue": "Wajik Biru Muda",
  "block.minecraft.banner.rhombus.light_gray": "Wajik Abu-Abu Muda",
  "block.minecraft.banner.rhombus.lime": "Wajik Hijau Pupus",
  "block.minecraft.banner.rhombus.magenta": "Wajik Magenta",
  "block.minecraft.banner.rhombus.orange": "Wajik Jingga",
  "block.minecraft.banner.rhombus.pink": "Wajik Merah Muda",
  "block.minecraft.banner.rhombus.purple": "Wajik Ungu",
  "block.minecraft.banner.rhombus.red": "Wajik Merah",
  "block.minecraft.banner.rhombus.white": "Wajik Putih",
  "block.minecraft.banner.rhombus.yellow": "Wajik Kuning",
  "block.minecraft.banner.skull.black": "Rupa Tengkorak Hitam",
  "block.minecraft.banner.skull.blue": "Rupa Tengkorak Biru",
  "block.minecraft.banner.skull.brown": "Rupa Tengkorak Cokelat",
  "block.minecraft.banner.skull.cyan": "Rupa Tengkorak Sian",
  "block.minecraft.banner.skull.gray": "Rupa Tengkorak Abu-Abu",
  "block.minecraft.banner.skull.green": "Rupa Tengkorak Hijau",
  "block.minecraft.banner.skull.light_blue": "Rupa Tengkorak Biru Muda",
  "block.minecraft.banner.skull.light_gray": "Rupa Tengkorak Abu-Abu Muda",
  "block.minecraft.banner.skull.lime": "Rupa Tengkorak Hijau Pupus",
  "block.minecraft.banner.skull.magenta": "Rupa Tengkorak Magenta",
  "block.minecraft.banner.skull.orange": "Rupa Tengkorak Jingga",
  "block.minecraft.banner.skull.pink": "Rupa Tengkorak Merah Muda",
  "block.minecraft.banner.skull.purple": "Rupa Tengkorak Ungu",
  "block.minecraft.banner.skull.red": "Rupa Tengkorak Merah",
  "block.minecraft.banner.skull.white": "Rupa Tengkorak Putih",
  "block.minecraft.banner.skull.yellow": "Rupa Tengkorak Kuning",
  "block.minecraft.banner.small_stripes.black": "Tonggak-Tonggak Hitam",
  "block.minecraft.banner.small_stripes.blue": "Tonggak-Tonggak Biru",
  "block.minecraft.banner.small_stripes.brown": "Tonggak-Tonggak Cokelat",
  "block.minecraft.banner.small_stripes.cyan": "Tonggak-Tonggak Sian",
  "block.minecraft.banner.small_stripes.gray": "Tonggak-Tonggak Abu-Abu",
  "block.minecraft.banner.small_stripes.green": "Tonggak-Tonggak Hijau",
  "block.minecraft.banner.small_stripes.light_blue": "Tonggak-Tonggak Biru Muda",
  "block.minecraft.banner.small_stripes.light_gray": "Tonggak-Tonggak Abu-Abu Muda",
  "block.minecraft.banner.small_stripes.lime": "Tonggak-Tonggak Hijau Pupus",
  "block.minecraft.banner.small_stripes.magenta": "Tonggak-Tonggak Magenta",
  "block.minecraft.banner.small_stripes.orange": "Tonggak-Tonggak Jingga",
  "block.minecraft.banner.small_stripes.pink": "Tonggak-Tonggak Merah Muda",
  "block.minecraft.banner.small_stripes.purple": "Tonggak-Tonggak Ungu",
  "block.minecraft.banner.small_stripes.red": "Tonggak-Tonggak Merah",
  "block.minecraft.banner.small_stripes.white": "Tonggak-Tonggak Putih",
  "block.minecraft.banner.small_stripes.yellow": "Tonggak-Tonggak Kuning",
  "block.minecraft.banner.square_bottom_left.black": "Petak Dasar Kinan Hitam",
  "block.minecraft.banner.square_bottom_left.blue": "Petak Dasar Kinan Biru",
  "block.minecraft.banner.square_bottom_left.brown": "Petak Dasar Kinan Cokelat",
  "block.minecraft.banner.square_bottom_left.cyan": "Petak Dasar Kinan Sian",
  "block.minecraft.banner.square_bottom_left.gray": "Petak Dasar Kinan Abu-Abu",
  "block.minecraft.banner.square_bottom_left.green": "Petak Dasar Kinan Hijau",
  "block.minecraft.banner.square_bottom_left.light_blue": "Petak Dasar Kinan Biru Muda",
  "block.minecraft.banner.square_bottom_left.light_gray": "Petak Dasar Kinan Abu-Abu Muda",
  "block.minecraft.banner.square_bottom_left.lime": "Petak Dasar Kinan Hijau Pupus",
  "block.minecraft.banner.square_bottom_left.magenta": "Petak Dasar Kinan Magenta",
  "block.minecraft.banner.square_bottom_left.orange": "Petak Dasar Kinan Jingga",
  "block.minecraft.banner.square_bottom_left.pink": "Petak Dasar Kinan Merah Muda",
  "block.minecraft.banner.square_bottom_left.purple": "Petak Dasar Kinan Ungu",
  "block.minecraft.banner.square_bottom_left.red": "Petak Dasar Kinan Merah",
  "block.minecraft.banner.square_bottom_left.white": "Petak Dasar Kinan Putih",
  "block.minecraft.banner.square_bottom_left.yellow": "Petak Dasar Kinan Kuning",
  "block.minecraft.banner.square_bottom_right.black": "Petak Dasar Kidal Hitam",
  "block.minecraft.banner.square_bottom_right.blue": "Petak Dasar Kidal Biru",
  "block.minecraft.banner.square_bottom_right.brown": "Petak Dasar Kidal Cokelat",
  "block.minecraft.banner.square_bottom_right.cyan": "Petak Dasar Kidal Sian",
  "block.minecraft.banner.square_bottom_right.gray": "Petak Dasar Kidal Abu-Abu",
  "block.minecraft.banner.square_bottom_right.green": "Petak Dasar Kidal Hijau",
  "block.minecraft.banner.square_bottom_right.light_blue": "Petak Dasar Kidal Biru Muda",
  "block.minecraft.banner.square_bottom_right.light_gray": "Petak Dasar Kidal Abu-Abu Muda",
  "block.minecraft.banner.square_bottom_right.lime": "Petak Dasar Kidal Hijau Pupus",
  "block.minecraft.banner.square_bottom_right.magenta": "Petak Dasar Kidal Magenta",
  "block.minecraft.banner.square_bottom_right.orange": "Petak Dasar Kidal Jingga",
  "block.minecraft.banner.square_bottom_right.pink": "Petak Dasar Kidal Merah Muda",
  "block.minecraft.banner.square_bottom_right.purple": "Petak Dasar Kidal Ungu",
  "block.minecraft.banner.square_bottom_right.red": "Petak Dasar Kidal Merah",
  "block.minecraft.banner.square_bottom_right.white": "Petak Dasar Kidal Putih",
  "block.minecraft.banner.square_bottom_right.yellow": "Petak Dasar Kidal Kuning",
  "block.minecraft.banner.square_top_left.black": "Petak Hulu Kinan Hitam",
  "block.minecraft.banner.square_top_left.blue": "Petak Hulu Kinan Biru",
  "block.minecraft.banner.square_top_left.brown": "Petak Hulu Kinan Cokelat",
  "block.minecraft.banner.square_top_left.cyan": "Petak Hulu Kinan Sian",
  "block.minecraft.banner.square_top_left.gray": "Petak Hulu Kinan Abu-Abu",
  "block.minecraft.banner.square_top_left.green": "Petak Hulu Kinan Hijau",
  "block.minecraft.banner.square_top_left.light_blue": "Petak Hulu Kinan Biru Muda",
  "block.minecraft.banner.square_top_left.light_gray": "Petak Hulu Kinan Abu-Abu Muda",
  "block.minecraft.banner.square_top_left.lime": "Petak Hulu Kinan Hijau Pupus",
  "block.minecraft.banner.square_top_left.magenta": "Petak Hulu Kinan Magenta",
  "block.minecraft.banner.square_top_left.orange": "Petak Hulu Kinan Jingga",
  "block.minecraft.banner.square_top_left.pink": "Petak Hulu Kinan Merah Muda",
  "block.minecraft.banner.square_top_left.purple": "Petak Hulu Kinan Ungu",
  "block.minecraft.banner.square_top_left.red": "Petak Hulu Kinan Merah",
  "block.minecraft.banner.square_top_left.white": "Petak Hulu Kinan Putih",
  "block.minecraft.banner.square_top_left.yellow": "Petak Hulu Kinan Kuning",
  "block.minecraft.banner.square_top_right.black": "Petak Hulu Kidal Hitam",
  "block.minecraft.banner.square_top_right.blue": "Petak Hulu Kidal Biru",
  "block.minecraft.banner.square_top_right.brown": "Petak Hulu Kidal Cokelat",
  "block.minecraft.banner.square_top_right.cyan": "Petak Hulu Kidal Sian",
  "block.minecraft.banner.square_top_right.gray": "Petak Hulu Kidal Abu-Abu",
  "block.minecraft.banner.square_top_right.green": "Petak Hulu Kidal Hijau",
  "block.minecraft.banner.square_top_right.light_blue": "Petak Hulu Kidal Biru Muda",
  "block.minecraft.banner.square_top_right.light_gray": "Petak Hulu Kidal Abu-Abu Muda",
  "block.minecraft.banner.square_top_right.lime": "Petak Hulu Kidal Hijau Pupus",
  "block.minecraft.banner.square_top_right.magenta": "Petak Hulu Kidal Magenta",
  "block.minecraft.banner.square_top_right.orange": "Petak Hulu Kidal Jingga",
  "block.minecraft.banner.square_top_right.pink": "Petak Hulu Kidal Merah Muda",
  "block.minecraft.banner.square_top_right.purple": "Petak Hulu Kidal Atas Ungu",
  "block.minecraft.banner.square_top_right.red": "Petak Hulu Kidal Atas Merah",
  "block.minecraft.banner.square_top_right.white": "Petak Hulu Kidal Putih",
  "block.minecraft.banner.square_top_right.yellow": "Petak Hulu Kidal Kuning",
  "block.minecraft.banner.straight_cross.black": "Palang Hitam",
  "block.minecraft.banner.straight_cross.blue": "Palang Biru",
  "block.minecraft.banner.straight_cross.brown": "Palang Cokelat",
  "block.minecraft.banner.straight_cross.cyan": "Palang Sian",
  "block.minecraft.banner.straight_cross.gray": "Palang Abu-Abu",
  "block.minecraft.banner.straight_cross.green": "Palang Hijau",
  "block.minecraft.banner.straight_cross.light_blue": "Palang Biru Muda",
  "block.minecraft.banner.straight_cross.light_gray": "Palang Abu-Abu Muda",
  "block.minecraft.banner.straight_cross.lime": "Palang Hijau Pupus",
  "block.minecraft.banner.straight_cross.magenta": "Palang Magenta",
  "block.minecraft.banner.straight_cross.orange": "Palang Jingga",
  "block.minecraft.banner.straight_cross.pink": "Palang Merah Muda",
  "block.minecraft.banner.straight_cross.purple": "Palang Ungu",
  "block.minecraft.banner.straight_cross.red": "Palang Merah",
  "block.minecraft.banner.straight_cross.white": "Palang Putih",
  "block.minecraft.banner.straight_cross.yellow": "Palang Kuning",
  "block.minecraft.banner.stripe_bottom.black": "Dasar Hitam",
  "block.minecraft.banner.stripe_bottom.blue": "Dasar Biru",
  "block.minecraft.banner.stripe_bottom.brown": "Dasar Cokelat",
  "block.minecraft.banner.stripe_bottom.cyan": "Dasar Sian",
  "block.minecraft.banner.stripe_bottom.gray": "Dasar Abu-Abu",
  "block.minecraft.banner.stripe_bottom.green": "Dasar Hijau",
  "block.minecraft.banner.stripe_bottom.light_blue": "Dasar Biru Muda",
  "block.minecraft.banner.stripe_bottom.light_gray": "Dasar Abu-Abu Muda",
  "block.minecraft.banner.stripe_bottom.lime": "Dasar Hijau Pupus",
  "block.minecraft.banner.stripe_bottom.magenta": "Dasar Magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Dasar Jingga",
  "block.minecraft.banner.stripe_bottom.pink": "Dasar Merah Muda",
  "block.minecraft.banner.stripe_bottom.purple": "Dasar Ungu",
  "block.minecraft.banner.stripe_bottom.red": "Dasar Merah",
  "block.minecraft.banner.stripe_bottom.white": "Dasar Putih",
  "block.minecraft.banner.stripe_bottom.yellow": "Dasar Kuning",
  "block.minecraft.banner.stripe_center.black": "Tonggak Hitam",
  "block.minecraft.banner.stripe_center.blue": "Tonggak Biru",
  "block.minecraft.banner.stripe_center.brown": "Tonggak Cokelat",
  "block.minecraft.banner.stripe_center.cyan": "Tonggak Sian",
  "block.minecraft.banner.stripe_center.gray": "Tonggak Abu-Abu",
  "block.minecraft.banner.stripe_center.green": "Tonggak Hijau",
  "block.minecraft.banner.stripe_center.light_blue": "Tonggak Biru Muda",
  "block.minecraft.banner.stripe_center.light_gray": "Tonggak Abu-Abu Muda",
  "block.minecraft.banner.stripe_center.lime": "Tonggak Hijau Pupus",
  "block.minecraft.banner.stripe_center.magenta": "Tonggak Magenta",
  "block.minecraft.banner.stripe_center.orange": "Tonggak Jingga",
  "block.minecraft.banner.stripe_center.pink": "Tonggak Merah Muda",
  "block.minecraft.banner.stripe_center.purple": "Tonggak Ungu",
  "block.minecraft.banner.stripe_center.red": "Tonggak Merah",
  "block.minecraft.banner.stripe_center.white": "Tonggak Putih",
  "block.minecraft.banner.stripe_center.yellow": "Tonggak Kuning",
  "block.minecraft.banner.stripe_downleft.black": "Serongan Kidal Hitam",
  "block.minecraft.banner.stripe_downleft.blue": "Serongan Kidal Biru",
  "block.minecraft.banner.stripe_downleft.brown": "Serongan Kidal Cokelat",
  "block.minecraft.banner.stripe_downleft.cyan": "Serongan Kidal Sian",
  "block.minecraft.banner.stripe_downleft.gray": "Serongan Kidal Abu-Abu",
  "block.minecraft.banner.stripe_downleft.green": "Serongan Kidal Hijau",
  "block.minecraft.banner.stripe_downleft.light_blue": "Serongan Kidal Biru Muda",
  "block.minecraft.banner.stripe_downleft.light_gray": "Serongan Kidal Abu-Abu Muda",
  "block.minecraft.banner.stripe_downleft.lime": "Serongan Kidal Hijau Pupus",
  "block.minecraft.banner.stripe_downleft.magenta": "Serongan Kidal Magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Serongan Kidal Jingga",
  "block.minecraft.banner.stripe_downleft.pink": "Serongan Kidal Merah Muda",
  "block.minecraft.banner.stripe_downleft.purple": "Serongan Kidal Ungu",
  "block.minecraft.banner.stripe_downleft.red": "Serongan Kidal Merah",
  "block.minecraft.banner.stripe_downleft.white": "Serongan Kidal Putih",
  "block.minecraft.banner.stripe_downleft.yellow": "Serongan Kidal Kuning",
  "block.minecraft.banner.stripe_downright.black": "Serongan Hitam",
  "block.minecraft.banner.stripe_downright.blue": "Serongan Biru",
  "block.minecraft.banner.stripe_downright.brown": "Serongan Cokelat",
  "block.minecraft.banner.stripe_downright.cyan": "Serongan Sian",
  "block.minecraft.banner.stripe_downright.gray": "Serongan Abu-Abu",
  "block.minecraft.banner.stripe_downright.green": "Serongan Hijau",
  "block.minecraft.banner.stripe_downright.light_blue": "Serongan Biru Muda",
  "block.minecraft.banner.stripe_downright.light_gray": "Serongan Abu-Abu Muda",
  "block.minecraft.banner.stripe_downright.lime": "Serongan Hijau Pupus",
  "block.minecraft.banner.stripe_downright.magenta": "Serongan Magenta",
  "block.minecraft.banner.stripe_downright.orange": "Serongan Jingga",
  "block.minecraft.banner.stripe_downright.pink": "Serongan Merah Muda",
  "block.minecraft.banner.stripe_downright.purple": "Serongan Ungu",
  "block.minecraft.banner.stripe_downright.red": "Serongan Merah",
  "block.minecraft.banner.stripe_downright.white": "Serongan Putih",
  "block.minecraft.banner.stripe_downright.yellow": "Serongan Kuning",
  "block.minecraft.banner.stripe_left.black": "Tonggak Kinan Hitam",
  "block.minecraft.banner.stripe_left.blue": "Tonggak Kinan Biru",
  "block.minecraft.banner.stripe_left.brown": "Tonggak Kinan Cokelat",
  "block.minecraft.banner.stripe_left.cyan": "Tonggak Kinan Sian",
  "block.minecraft.banner.stripe_left.gray": "Tonggak Kinan Abu-Abu",
  "block.minecraft.banner.stripe_left.green": "Tonggak Kinan Hijau",
  "block.minecraft.banner.stripe_left.light_blue": "Tonggak Kinan Biru Muda",
  "block.minecraft.banner.stripe_left.light_gray": "Tonggak Kinan Abu-Abu Muda",
  "block.minecraft.banner.stripe_left.lime": "Tonggak Kinan Hijau Pupus",
  "block.minecraft.banner.stripe_left.magenta": "Tonggak Kinan Magenta",
  "block.minecraft.banner.stripe_left.orange": "Tonggak Kinan Jingga",
  "block.minecraft.banner.stripe_left.pink": "Tonggak Kinan Merah Muda",
  "block.minecraft.banner.stripe_left.purple": "Tonggak Kinan Ungu",
  "block.minecraft.banner.stripe_left.red": "Tonggak Kinan Merah",
  "block.minecraft.banner.stripe_left.white": "Tonggak Kinan Putih",
  "block.minecraft.banner.stripe_left.yellow": "Tonggak Kinan Kuning",
  "block.minecraft.banner.stripe_middle.black": "Jalur Hitam",
  "block.minecraft.banner.stripe_middle.blue": "Jalur Biru",
  "block.minecraft.banner.stripe_middle.brown": "Jalur Cokelat",
  "block.minecraft.banner.stripe_middle.cyan": "Jalur Sian",
  "block.minecraft.banner.stripe_middle.gray": "Jalur Abu-Abu",
  "block.minecraft.banner.stripe_middle.green": "Jalur Hijau",
  "block.minecraft.banner.stripe_middle.light_blue": "Jalur Biru Muda",
  "block.minecraft.banner.stripe_middle.light_gray": "Jalur Abu-Abu Muda",
  "block.minecraft.banner.stripe_middle.lime": "Jalur Hijau Pupus",
  "block.minecraft.banner.stripe_middle.magenta": "Jalur Magenta",
  "block.minecraft.banner.stripe_middle.orange": "Jalur Jingga",
  "block.minecraft.banner.stripe_middle.pink": "Jalur Merah Muda",
  "block.minecraft.banner.stripe_middle.purple": "Jalur Ungu",
  "block.minecraft.banner.stripe_middle.red": "Jalur Merah",
  "block.minecraft.banner.stripe_middle.white": "Jalur Putih",
  "block.minecraft.banner.stripe_middle.yellow": "Jalur Kuning",
  "block.minecraft.banner.stripe_right.black": "Tonggak Kidal Hitam",
  "block.minecraft.banner.stripe_right.blue": "Tonggak Kidal Biru",
  "block.minecraft.banner.stripe_right.brown": "Tonggak Kidal Cokelat",
  "block.minecraft.banner.stripe_right.cyan": "Tonggak Kidal Sian",
  "block.minecraft.banner.stripe_right.gray": "Tonggak Kidal Abu-Abu",
  "block.minecraft.banner.stripe_right.green": "Tonggak Kidal Hijau",
  "block.minecraft.banner.stripe_right.light_blue": "Tonggak Kidal Muda",
  "block.minecraft.banner.stripe_right.light_gray": "Tonggak Kidal Abu-Abu Muda",
  "block.minecraft.banner.stripe_right.lime": "Tonggak Kidal Hijau Pupus",
  "block.minecraft.banner.stripe_right.magenta": "Tonggak Kidal Magenta",
  "block.minecraft.banner.stripe_right.orange": "Tonggak Kidal Jingga",
  "block.minecraft.banner.stripe_right.pink": "Tonggak Kidal Merah Muda",
  "block.minecraft.banner.stripe_right.purple": "Tonggak Kidal Ungu",
  "block.minecraft.banner.stripe_right.red": "Tonggak Kidal Merah",
  "block.minecraft.banner.stripe_right.white": "Tonggak Kidal Putih",
  "block.minecraft.banner.stripe_right.yellow": "Tonggak Kidal Kuning",
  "block.minecraft.banner.stripe_top.black": "Hulu Hitam",
  "block.minecraft.banner.stripe_top.blue": "Hulu Biru",
  "block.minecraft.banner.stripe_top.brown": "Hulu Cokelat",
  "block.minecraft.banner.stripe_top.cyan": "Hulu Sian",
  "block.minecraft.banner.stripe_top.gray": "Hulu Abu-Abu",
  "block.minecraft.banner.stripe_top.green": "Hulu Hijau",
  "block.minecraft.banner.stripe_top.light_blue": "Hulu Biru Muda",
  "block.minecraft.banner.stripe_top.light_gray": "Hulu Abu-Abu Muda",
  "block.minecraft.banner.stripe_top.lime": "Hulu Hijau Pupus",
  "block.minecraft.banner.stripe_top.magenta": "Hulu Magenta",
  "block.minecraft.banner.stripe_top.orange": "Hulu Jingga",
  "block.minecraft.banner.stripe_top.pink": "Hulu Merah Muda",
  "block.minecraft.banner.stripe_top.purple": "Hulu Ungu",
  "block.minecraft.banner.stripe_top.red": "Hulu Merah",
  "block.minecraft.banner.stripe_top.white": "Hulu Putih",
  "block.minecraft.banner.stripe_top.yellow": "Hulu Kuning",
  "block.minecraft.banner.triangle_bottom.black": "Takuk Hitam",
  "block.minecraft.banner.triangle_bottom.blue": "Takuk Biru",
  "block.minecraft.banner.triangle_bottom.brown": "Takuk Cokelat",
  "block.minecraft.banner.triangle_bottom.cyan": "Takuk Sian",
  "block.minecraft.banner.triangle_bottom.gray": "Takuk Abu-Abu",
  "block.minecraft.banner.triangle_bottom.green": "Takuk Hijau",
  "block.minecraft.banner.triangle_bottom.light_blue": "Takuk Biru Muda",
  "block.minecraft.banner.triangle_bottom.light_gray": "Takuk Abu-Abu Muda",
  "block.minecraft.banner.triangle_bottom.lime": "Takuk Hijau Pupus",
  "block.minecraft.banner.triangle_bottom.magenta": "Takuk Magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Takuk Jingga",
  "block.minecraft.banner.triangle_bottom.pink": "Takuk Merah Muda",
  "block.minecraft.banner.triangle_bottom.purple": "Takuk Ungu",
  "block.minecraft.banner.triangle_bottom.red": "Takuk Merah",
  "block.minecraft.banner.triangle_bottom.white": "Takuk Putih",
  "block.minecraft.banner.triangle_bottom.yellow": "Takuk Kuning",
  "block.minecraft.banner.triangle_top.black": "Takuk Sungsang Hitam",
  "block.minecraft.banner.triangle_top.blue": "Takuk Sungsang Biru",
  "block.minecraft.banner.triangle_top.brown": "Takuk Sungsang Cokelat",
  "block.minecraft.banner.triangle_top.cyan": "Takuk Sungsang Sian",
  "block.minecraft.banner.triangle_top.gray": "Takuk Sungsang Abu-Abu",
  "block.minecraft.banner.triangle_top.green": "Takuk Sungsang Hijau",
  "block.minecraft.banner.triangle_top.light_blue": "Takuk Sungsang Biru Muda",
  "block.minecraft.banner.triangle_top.light_gray": "Takuk Sungsang Abu-Abu Muda",
  "block.minecraft.banner.triangle_top.lime": "Takuk Sungsang Hijau Pupus",
  "block.minecraft.banner.triangle_top.magenta": "Takuk Sungsang Magenta",
  "block.minecraft.banner.triangle_top.orange": "Takuk Sungsang Jingga",
  "block.minecraft.banner.triangle_top.pink": "Takuk Sungsang Merah Muda",
  "block.minecraft.banner.triangle_top.purple": "Takuk Sungsang Ungu",
  "block.minecraft.banner.triangle_top.red": "Takuk Sungsang Merah",
  "block.minecraft.banner.triangle_top.white": "Takuk Sungsang Putih",
  "block.minecraft.banner.triangle_top.yellow": "Takuk Sungsang Kuning",
  "block.minecraft.banner.triangles_bottom.black": "Dasar Bertakik Hitam",
  "block.minecraft.banner.triangles_bottom.blue": "Dasar Bertakik Biru",
  "block.minecraft.banner.triangles_bottom.brown": "Dasar Bertakik Cokelat",
  "block.minecraft.banner.triangles_bottom.cyan": "Dasar Bertakik Sian",
  "block.minecraft.banner.triangles_bottom.gray": "Dasar Bertakik Abu-Abu",
  "block.minecraft.banner.triangles_bottom.green": "Dasar Bertakik Hijau",
  "block.minecraft.banner.triangles_bottom.light_blue": "Dasar Bertakik Biru Muda",
  "block.minecraft.banner.triangles_bottom.light_gray": "Dasar Bertakik Abu-Abu Muda",
  "block.minecraft.banner.triangles_bottom.lime": "Dasar Bertakik Hijau Pupus",
  "block.minecraft.banner.triangles_bottom.magenta": "Dasar Bertakik Magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Dasar Bertakik Jingga",
  "block.minecraft.banner.triangles_bottom.pink": "Dasar Bertakik Merah Muda",
  "block.minecraft.banner.triangles_bottom.purple": "Dasar Bertakik Ungu",
  "block.minecraft.banner.triangles_bottom.red": "Dasar Bertakik Merah",
  "block.minecraft.banner.triangles_bottom.white": "Dasar Bertakik Putih",
  "block.minecraft.banner.triangles_bottom.yellow": "Dasar Bertakik Kuning",
  "block.minecraft.banner.triangles_top.black": "Hulu Bertakik Hitam",
  "block.minecraft.banner.triangles_top.blue": "Hulu Bertakik Biru",
  "block.minecraft.banner.triangles_top.brown": "Hulu Bertakik Cokelat",
  "block.minecraft.banner.triangles_top.cyan": "Hulu Bertakik Sian",
  "block.minecraft.banner.triangles_top.gray": "Hulu Bertakik Abu-Abu",
  "block.minecraft.banner.triangles_top.green": "Hulu Bertakik Hijau",
  "block.minecraft.banner.triangles_top.light_blue": "Hulu Bertakik Biru Muda",
  "block.minecraft.banner.triangles_top.light_gray": "Hulu Bertakik Abu-Abu Muda",
  "block.minecraft.banner.triangles_top.lime": "Hulu Bertakik Hijau Pupus",
  "block.minecraft.banner.triangles_top.magenta": "Hulu Bertakik Magenta",
  "block.minecraft.banner.triangles_top.orange": "Hulu Bertakik Jingga",
  "block.minecraft.banner.triangles_top.pink": "Hulu Bertakik Merah Muda",
  "block.minecraft.banner.triangles_top.purple": "Hulu Bertakik Ungu",
  "block.minecraft.banner.triangles_top.red": "Hulu Bertakik Merah",
  "block.minecraft.banner.triangles_top.white": "Hulu Bertakik Putih",
  "block.minecraft.banner.triangles_top.yellow": "Hulu Bertakik Kuning",
  "block.minecraft.barrel": "Tong",
  "block.minecraft.barrier": "Penghalang",
  "block.minecraft.basalt": "Basal",
  "block.minecraft.beacon": "Suar",
  "block.minecraft.beacon.primary": "Kekuatan Utama",
  "block.minecraft.beacon.secondary": "Kekuatan Sekunder",
  "block.minecraft.bed.no_sleep": "Anda hanya dapat tidur saat malam atau selama badai petir",
  "block.minecraft.bed.not_safe": "Anda tak dapat tidur sekarang, banyak monster dekat sini",
  "block.minecraft.bed.obstructed": "Tempat tidur ini terhalangi",
  "block.minecraft.bed.occupied": "Tempat tidur ini ditempati",
  "block.minecraft.bed.too_far_away": "Anda tidak dapat beristirahat sekarang, tempat tidur terlalu jauh",
  "block.minecraft.bedrock": "Batu Dasar",
  "block.minecraft.bee_nest": "Sarang Lebah",
  "block.minecraft.beehive": "Sarang Lebah Buatan",
  "block.minecraft.beetroots": "Bit",
  "block.minecraft.bell": "Lonceng",
  "block.minecraft.big_dripleaf": "Daun Tetes Besar",
  "block.minecraft.big_dripleaf_stem": "Batang Daun Tetes Besar",
  "block.minecraft.birch_button": "Tombol Betula",
  "block.minecraft.birch_door": "Pintu Betula",
  "block.minecraft.birch_fence": "Pagar Betula",
  "block.minecraft.birch_fence_gate": "Pintu Pagar Betula",
  "block.minecraft.birch_hanging_sign": "Papan Tanda Gantung Betula",
  "block.minecraft.birch_leaves": "Daun Betula",
  "block.minecraft.birch_log": "Gelondong Betula",
  "block.minecraft.birch_planks": "Papan Betula",
  "block.minecraft.birch_pressure_plate": "Pelat Penekan Betula",
  "block.minecraft.birch_sapling": "Bibit Betula",
  "block.minecraft.birch_shelf": "Rak Betula",
  "block.minecraft.birch_sign": "Papan Tanda Betula",
  "block.minecraft.birch_slab": "Lempeng Betula",
  "block.minecraft.birch_stairs": "Tangga Betula",
  "block.minecraft.birch_trapdoor": "Pintu Kolong Betula",
  "block.minecraft.birch_wall_hanging_sign": "Papan Tanda Gantung Dinding Betula",
  "block.minecraft.birch_wall_sign": "Papan Tanda Dinding Betula",
  "block.minecraft.birch_wood": "Kayu Betula",
  "block.minecraft.black_banner": "Panji Hitam",
  "block.minecraft.black_bed": "Tempat Tidur Hitam",
  "block.minecraft.black_candle": "Lilin Hitam",
  "block.minecraft.black_candle_cake": "Kue dengan Lilin Hitam",
  "block.minecraft.black_carpet": "Karpet Hitam",
  "block.minecraft.black_concrete": "Beton Hitam",
  "block.minecraft.black_concrete_powder": "Semen Hitam",
  "block.minecraft.black_glazed_terracotta": "Terakota Berglasir Hitam",
  "block.minecraft.black_shulker_box": "Kotak Shulker Hitam",
  "block.minecraft.black_stained_glass": "Kaca Berwarna Hitam",
  "block.minecraft.black_stained_glass_pane": "Panel Kaca Berwarna Hitam",
  "block.minecraft.black_terracotta": "Terakota Hitam",
  "block.minecraft.black_wool": "Wol Hitam",
  "block.minecraft.blackstone": "Batu Hitam",
  "block.minecraft.blackstone_slab": "Lempeng Batu Hitam",
  "block.minecraft.blackstone_stairs": "Tangga Batu Hitam",
  "block.minecraft.blackstone_wall": "Tembok Batu Hitam",
  "block.minecraft.blast_furnace": "Tanur Tiup",
  "block.minecraft.blue_banner": "Panji Biru",
  "block.minecraft.blue_bed": "Tempat Tidur Biru",
  "block.minecraft.blue_candle": "Lilin Biru",
  "block.minecraft.blue_candle_cake": "Kue dengan Lilin Biru",
  "block.minecraft.blue_carpet": "Karpet Biru",
  "block.minecraft.blue_concrete": "Beton Biru",
  "block.minecraft.blue_concrete_powder": "Semen Biru",
  "block.minecraft.blue_glazed_terracotta": "Terakota Berglasir Biru",
  "block.minecraft.blue_ice": "Es Biru",
  "block.minecraft.blue_orchid": "Anggrek Biru",
  "block.minecraft.blue_shulker_box": "Kotak Shulker Biru",
  "block.minecraft.blue_stained_glass": "Kaca Berwarna Biru",
  "block.minecraft.blue_stained_glass_pane": "Panel Kaca Berwarna Biru",
  "block.minecraft.blue_terracotta": "Terakota Biru",
  "block.minecraft.blue_wool": "Wol Biru",
  "block.minecraft.bone_block": "Balok Tulang",
  "block.minecraft.bookshelf": "Rak Buku",
  "block.minecraft.brain_coral": "Karang Otak",
  "block.minecraft.brain_coral_block": "Balok Karang Otak",
  "block.minecraft.brain_coral_fan": "Kipas Laut Otak",
  "block.minecraft.brain_coral_wall_fan": "Kipas Laut Otak Dinding",
  "block.minecraft.brewing_stand": "Alat Peramuan",
  "block.minecraft.brick_slab": "Lempeng Bata",
  "block.minecraft.brick_stairs": "Tangga Bata",
  "block.minecraft.brick_wall": "Tembok Bata",
  "block.minecraft.bricks": "Balok Bata",
  "block.minecraft.brown_banner": "Panji Cokelat",
  "block.minecraft.brown_bed": "Tempat Tidur Cokelat",
  "block.minecraft.brown_candle": "Lilin Cokelat",
  "block.minecraft.brown_candle_cake": "Kue dengan Lilin Cokelat",
  "block.minecraft.brown_carpet": "Karpet Cokelat",
  "block.minecraft.brown_concrete": "Beton Cokelat",
  "block.minecraft.brown_concrete_powder": "Semen Cokelat",
  "block.minecraft.brown_glazed_terracotta": "Terakota Berglasir Cokelat",
  "block.minecraft.brown_mushroom": "Jamur Cokelat",
  "block.minecraft.brown_mushroom_block": "Balok Jamur Cokelat",
  "block.minecraft.brown_shulker_box": "Kotak Shulker Cokelat",
  "block.minecraft.brown_stained_glass": "Kaca Berwarna Cokelat",
  "block.minecraft.brown_stained_glass_pane": "Panel Kaca Berwarna Cokelat",
  "block.minecraft.brown_terracotta": "Terakota Cokelat",
  "block.minecraft.brown_wool": "Wol Cokelat",
  "block.minecraft.bubble_column": "Lajur Gelembung",
  "block.minecraft.bubble_coral": "Karang Gelembung",
  "block.minecraft.bubble_coral_block": "Balok Karang Gelembung",
  "block.minecraft.bubble_coral_fan": "Kipas Laut Gelembung",
  "block.minecraft.bubble_coral_wall_fan": "Kipas Laut Gelembung Dinding",
  "block.minecraft.budding_amethyst": "Kecubung Berkuncup",
  "block.minecraft.bush": "Semak",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Bunga Kaktus",
  "block.minecraft.cake": "Kue",
  "block.minecraft.calcite": "Kalsit",
  "block.minecraft.calibrated_sculk_sensor": "Sensor Sculk Terkalibrasi",
  "block.minecraft.campfire": "Api Unggun",
  "block.minecraft.candle": "Lilin",
  "block.minecraft.candle_cake": "Kue dengan Lilin",
  "block.minecraft.carrots": "Wortel",
  "block.minecraft.cartography_table": "Meja Pemetaan",
  "block.minecraft.carved_pumpkin": "Labu Terukir",
  "block.minecraft.cauldron": "Kuali",
  "block.minecraft.cave_air": "Udara Gua",
  "block.minecraft.cave_vines": "Perambat Gua",
  "block.minecraft.cave_vines_plant": "Tanaman Perambat Gua",
  "block.minecraft.chain": "Rantai",
  "block.minecraft.chain_command_block": "Balok Perintah Berantai",
  "block.minecraft.cherry_button": "Tombol Ceri",
  "block.minecraft.cherry_door": "Pintu Ceri",
  "block.minecraft.cherry_fence": "Pagar Ceri",
  "block.minecraft.cherry_fence_gate": "Pintu Pagar Ceri",
  "block.minecraft.cherry_hanging_sign": "Papan Tanda Gantung Ceri",
  "block.minecraft.cherry_leaves": "Daun Ceri",
  "block.minecraft.cherry_log": "Gelondong Ceri",
  "block.minecraft.cherry_planks": "Papan Ceri",
  "block.minecraft.cherry_pressure_plate": "Pelat Penekan Ceri",
  "block.minecraft.cherry_sapling": "Bibit Ceri",
  "block.minecraft.cherry_shelf": "Rak Ceri",
  "block.minecraft.cherry_sign": "Papan Tanda Ceri",
  "block.minecraft.cherry_slab": "Lempeng Ceri",
  "block.minecraft.cherry_stairs": "Tangga Ceri",
  "block.minecraft.cherry_trapdoor": "Pintu Kolong Ceri",
  "block.minecraft.cherry_wall_hanging_sign": "Papan Tanda Gantung Dinding Ceri",
  "block.minecraft.cherry_wall_sign": "Papan Tanda Dinding Ceri",
  "block.minecraft.cherry_wood": "Kayu Ceri",
  "block.minecraft.chest": "Peti",
  "block.minecraft.chipped_anvil": "Paron Cuil",
  "block.minecraft.chiseled_bookshelf": "Rak Buku Pahatan",
  "block.minecraft.chiseled_copper": "Tembaga Pahatan",
  "block.minecraft.chiseled_deepslate": "Batu Sabak Pahatan",
  "block.minecraft.chiseled_nether_bricks": "Bata Nether Pahatan",
  "block.minecraft.chiseled_polished_blackstone": "Batu Hitam Gilap Pahatan",
  "block.minecraft.chiseled_quartz_block": "Balok Kuarsa Pahatan",
  "block.minecraft.chiseled_red_sandstone": "Batu Pasir Merah Pahatan",
  "block.minecraft.chiseled_resin_bricks": "Bata Resin Pahatan",
  "block.minecraft.chiseled_sandstone": "Batu Pasir Pahatan",
  "block.minecraft.chiseled_stone_bricks": "Bata Batu Pahatan",
  "block.minecraft.chiseled_tuff": "Tuf Pahatan",
  "block.minecraft.chiseled_tuff_bricks": "Bata Tuf Pahatan",
  "block.minecraft.chorus_flower": "Bunga Korus",
  "block.minecraft.chorus_plant": "Pohon Korus",
  "block.minecraft.clay": "Tanah Liat",
  "block.minecraft.closed_eyeblossom": "Bunga Mata Tertutup",
  "block.minecraft.coal_block": "Balok Batu Bara",
  "block.minecraft.coal_ore": "Bijih Batu Bara",
  "block.minecraft.coarse_dirt": "Tanah Kasar",
  "block.minecraft.cobbled_deepslate": "Batu Sabak Kasar",
  "block.minecraft.cobbled_deepslate_slab": "Lempeng Batu Sabak Kasar",
  "block.minecraft.cobbled_deepslate_stairs": "Tangga Batu Sabak Kasar",
  "block.minecraft.cobbled_deepslate_wall": "Tembok Batu Sabak Kasar",
  "block.minecraft.cobblestone": "Batu Kasar",
  "block.minecraft.cobblestone_slab": "Lempeng Batu Kasar",
  "block.minecraft.cobblestone_stairs": "Tangga Batu Kasar",
  "block.minecraft.cobblestone_wall": "Tembok Batu Kasar",
  "block.minecraft.cobweb": "Jaring Laba-Laba",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Balok Perintah",
  "block.minecraft.comparator": "Pembanding Redstone",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Talang",
  "block.minecraft.copper_bars": "Jeruji Tembaga",
  "block.minecraft.copper_block": "Balok Tembaga",
  "block.minecraft.copper_bulb": "Lampu Tembaga",
  "block.minecraft.copper_chain": "Rantai Tembaga",
  "block.minecraft.copper_chest": "Peti Tembaga",
  "block.minecraft.copper_door": "Pintu Tembaga",
  "block.minecraft.copper_golem_statue": "Patung Golem Tembaga",
  "block.minecraft.copper_grate": "Kisi-Kisi Tembaga",
  "block.minecraft.copper_lantern": "Lentera Tembaga",
  "block.minecraft.copper_ore": "Bijih Tembaga",
  "block.minecraft.copper_torch": "Obor Tembaga",
  "block.minecraft.copper_trapdoor": "Pintu Kolong Tembaga",
  "block.minecraft.copper_wall_torch": "Obor Dinding Tembaga",
  "block.minecraft.cornflower": "Bunga Jagung",
  "block.minecraft.cracked_deepslate_bricks": "Bata Batu Sabak Retak",
  "block.minecraft.cracked_deepslate_tiles": "Ubin Batu Sabak Retak",
  "block.minecraft.cracked_nether_bricks": "Bata Nether Retak",
  "block.minecraft.cracked_polished_blackstone_bricks": "Bata Batu Hitam Gilap Retak",
  "block.minecraft.cracked_stone_bricks": "Bata Batu Retak",
  "block.minecraft.crafter": "Mesin Kerajinan",
  "block.minecraft.crafting_table": "Meja Kerajinan",
  "block.minecraft.creaking_heart": "Jantung Keriut",
  "block.minecraft.creeper_head": "Kepala Creeper",
  "block.minecraft.creeper_wall_head": "Kepala Dinding Creeper",
  "block.minecraft.crimson_button": "Tombol Kirmizi",
  "block.minecraft.crimson_door": "Pintu Kirmizi",
  "block.minecraft.crimson_fence": "Pagar Kirmizi",
  "block.minecraft.crimson_fence_gate": "Pintu Pagar Kirmizi",
  "block.minecraft.crimson_fungus": "Jamur Kirmizi",
  "block.minecraft.crimson_hanging_sign": "Papan Tanda Gantung Kirmizi",
  "block.minecraft.crimson_hyphae": "Hifa Kirmizi",
  "block.minecraft.crimson_nylium": "Nilium Kirmizi",
  "block.minecraft.crimson_planks": "Papan Kirmizi",
  "block.minecraft.crimson_pressure_plate": "Pelat Penekan Kirmizi",
  "block.minecraft.crimson_roots": "Akar Kirmizi",
  "block.minecraft.crimson_shelf": "Rak Kirmizi",
  "block.minecraft.crimson_sign": "Papan Tanda Kirmizi",
  "block.minecraft.crimson_slab": "Lempeng Kirmizi",
  "block.minecraft.crimson_stairs": "Tangga Kirmizi",
  "block.minecraft.crimson_stem": "Batang Kirmizi",
  "block.minecraft.crimson_trapdoor": "Pintu Kolong Kirmizi",
  "block.minecraft.crimson_wall_hanging_sign": "Papan Tanda Gantung Dinding Kirmizi",
  "block.minecraft.crimson_wall_sign": "Papan Tanda Dinding Kirmizi",
  "block.minecraft.crying_obsidian": "Obsidian Menangis",
  "block.minecraft.cut_copper": "Tembaga Potongan",
  "block.minecraft.cut_copper_slab": "Lempeng Tembaga Potongan",
  "block.minecraft.cut_copper_stairs": "Tangga Tembaga Potongan",
  "block.minecraft.cut_red_sandstone": "Batu Pasir Merah Potongan",
  "block.minecraft.cut_red_sandstone_slab": "Lempeng Batu Pasir Merah Potongan",
  "block.minecraft.cut_sandstone": "Batu Pasir Potongan",
  "block.minecraft.cut_sandstone_slab": "Lempeng Batu Pasir Potongan",
  "block.minecraft.cyan_banner": "Panji Sian",
  "block.minecraft.cyan_bed": "Tempat Tidur Sian",
  "block.minecraft.cyan_candle": "Lilin Sian",
  "block.minecraft.cyan_candle_cake": "Kue dengan Lilin Sian",
  "block.minecraft.cyan_carpet": "Karpet Sian",
  "block.minecraft.cyan_concrete": "Beton Sian",
  "block.minecraft.cyan_concrete_powder": "Semen Sian",
  "block.minecraft.cyan_glazed_terracotta": "Terakota Berglasir Sian",
  "block.minecraft.cyan_shulker_box": "Kotak Shulker Sian",
  "block.minecraft.cyan_stained_glass": "Kaca Berwarna Sian",
  "block.minecraft.cyan_stained_glass_pane": "Panel Kaca Berwarna Sian",
  "block.minecraft.cyan_terracotta": "Terakota Sian",
  "block.minecraft.cyan_wool": "Wol Sian",
  "block.minecraft.damaged_anvil": "Paron Rusak",
  "block.minecraft.dandelion": "Randa Tapak",
  "block.minecraft.dark_oak_button": "Tombol Ek Gelap",
  "block.minecraft.dark_oak_door": "Pintu Ek Gelap",
  "block.minecraft.dark_oak_fence": "Pagar Ek Gelap",
  "block.minecraft.dark_oak_fence_gate": "Pintu Pagar Ek Gelap",
  "block.minecraft.dark_oak_hanging_sign": "Papan Tanda Gantung Ek Gelap",
  "block.minecraft.dark_oak_leaves": "Daun Ek Gelap",
  "block.minecraft.dark_oak_log": "Gelondong Ek Gelap",
  "block.minecraft.dark_oak_planks": "Papan Ek Gelap",
  "block.minecraft.dark_oak_pressure_plate": "Pelat Penekan Ek Gelap",
  "block.minecraft.dark_oak_sapling": "Bibit Ek Gelap",
  "block.minecraft.dark_oak_shelf": "Rak Ek Gelap",
  "block.minecraft.dark_oak_sign": "Papan Tanda Ek Gelap",
  "block.minecraft.dark_oak_slab": "Lempeng Ek Gelap",
  "block.minecraft.dark_oak_stairs": "Tangga Ek Gelap",
  "block.minecraft.dark_oak_trapdoor": "Pintu Kolong Ek Gelap",
  "block.minecraft.dark_oak_wall_hanging_sign": "Papan Tanda Gantung Dinding Ek Gelap",
  "block.minecraft.dark_oak_wall_sign": "Papan Tanda Dinding Ek Gelap",
  "block.minecraft.dark_oak_wood": "Kayu Ek Gelap",
  "block.minecraft.dark_prismarine": "Prismarine Gelap",
  "block.minecraft.dark_prismarine_slab": "Lempeng Prismarine Gelap",
  "block.minecraft.dark_prismarine_stairs": "Tangga Prismarine Gelap",
  "block.minecraft.daylight_detector": "Detektor Cahaya",
  "block.minecraft.dead_brain_coral": "Karang Otak Mati",
  "block.minecraft.dead_brain_coral_block": "Balok Karang Otak Mati",
  "block.minecraft.dead_brain_coral_fan": "Kipas Laut Otak Mati",
  "block.minecraft.dead_brain_coral_wall_fan": "Kipas Laut Otak Dinding Mati",
  "block.minecraft.dead_bubble_coral": "Karang Gelembung Mati",
  "block.minecraft.dead_bubble_coral_block": "Balok Karang Gelembung Mati",
  "block.minecraft.dead_bubble_coral_fan": "Kipas Laut Gelembung Mati",
  "block.minecraft.dead_bubble_coral_wall_fan": "Kipas Laut Gelembung Dinding Mati",
  "block.minecraft.dead_bush": "Semak Mati",
  "block.minecraft.dead_fire_coral": "Karang Api Mati",
  "block.minecraft.dead_fire_coral_block": "Balok Karang Api Mati",
  "block.minecraft.dead_fire_coral_fan": "Kipas Laut Api Mati",
  "block.minecraft.dead_fire_coral_wall_fan": "Kipas Laut Api Dinding Mati",
  "block.minecraft.dead_horn_coral": "Karang Tanduk Mati",
  "block.minecraft.dead_horn_coral_block": "Balok Karang Tanduk Mati",
  "block.minecraft.dead_horn_coral_fan": "Kipas Laut Tanduk Mati",
  "block.minecraft.dead_horn_coral_wall_fan": "Kipas Laut Tanduk Dinding Mati",
  "block.minecraft.dead_tube_coral": "Karang Pipa Mati",
  "block.minecraft.dead_tube_coral_block": "Balok Karang Pipa Mati",
  "block.minecraft.dead_tube_coral_fan": "Kipas Laut Pipa Mati",
  "block.minecraft.dead_tube_coral_wall_fan": "Kipas Laut Pipa Dinding Mati",
  "block.minecraft.decorated_pot": "Pasu",
  "block.minecraft.deepslate": "Batu Sabak",
  "block.minecraft.deepslate_brick_slab": "Lempeng Bata Batu Sabak",
  "block.minecraft.deepslate_brick_stairs": "Tangga Bata Batu Sabak",
  "block.minecraft.deepslate_brick_wall": "Tembok Bata Batu Sabak",
  "block.minecraft.deepslate_bricks": "Bata Batu Sabak",
  "block.minecraft.deepslate_coal_ore": "Bijih Batu Bara Batu Sabak",
  "block.minecraft.deepslate_copper_ore": "Bijih Tembaga Batu Sabak",
  "block.minecraft.deepslate_diamond_ore": "Bijih Berlian Batu Sabak",
  "block.minecraft.deepslate_emerald_ore": "Bijih Zamrud Batu Sabak",
  "block.minecraft.deepslate_gold_ore": "Bijih Emas Batu Sabak",
  "block.minecraft.deepslate_iron_ore": "Bijih Besi Batu Sabak",
  "block.minecraft.deepslate_lapis_ore": "Bijih Lazuardi Batu Sabak",
  "block.minecraft.deepslate_redstone_ore": "Bijih Redstone Batu Sabak",
  "block.minecraft.deepslate_tile_slab": "Lempeng Ubin Batu Sabak",
  "block.minecraft.deepslate_tile_stairs": "Tangga Ubin Batu Sabak",
  "block.minecraft.deepslate_tile_wall": "Tembok Ubin Batu Sabak",
  "block.minecraft.deepslate_tiles": "Ubin Batu Sabak",
  "block.minecraft.detector_rail": "Rel Detektor",
  "block.minecraft.diamond_block": "Balok Berlian",
  "block.minecraft.diamond_ore": "Bijih Berlian",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Lempeng Diorit",
  "block.minecraft.diorite_stairs": "Tangga Diorit",
  "block.minecraft.diorite_wall": "Tembok Diorit",
  "block.minecraft.dirt": "Tanah",
  "block.minecraft.dirt_path": "Rintis Tanah",
  "block.minecraft.dispenser": "Pelempar",
  "block.minecraft.dragon_egg": "Telur Naga",
  "block.minecraft.dragon_head": "Kepala Naga",
  "block.minecraft.dragon_wall_head": "Kepala Dinding Naga",
  "block.minecraft.dried_ghast": "Ghast Kering",
  "block.minecraft.dried_kelp_block": "Balok Kelp Kering",
  "block.minecraft.dripstone_block": "Balok Batu Tetes",
  "block.minecraft.dropper": "Penjatuh",
  "block.minecraft.emerald_block": "Balok Zamrud",
  "block.minecraft.emerald_ore": "Bijih Zamrud",
  "block.minecraft.enchanting_table": "Meja Pesona",
  "block.minecraft.end_gateway": "Gapura End",
  "block.minecraft.end_portal": "Gerbang End",
  "block.minecraft.end_portal_frame": "Bingkai Gerbang End",
  "block.minecraft.end_rod": "Tongkat End",
  "block.minecraft.end_stone": "Batu End",
  "block.minecraft.end_stone_brick_slab": "Lempeng Bata Batu End",
  "block.minecraft.end_stone_brick_stairs": "Tangga Bata Batu End",
  "block.minecraft.end_stone_brick_wall": "Tembok Bata Batu End",
  "block.minecraft.end_stone_bricks": "Bata Batu End",
  "block.minecraft.ender_chest": "Peti Ender",
  "block.minecraft.exposed_chiseled_copper": "Tembaga Pahatan Terekspos",
  "block.minecraft.exposed_copper": "Tembaga Terekspos",
  "block.minecraft.exposed_copper_bars": "Jeruji Tembaga Terekspos",
  "block.minecraft.exposed_copper_bulb": "Lampu Tembaga Terekspos",
  "block.minecraft.exposed_copper_chain": "Rantai Tembaga Terekspos",
  "block.minecraft.exposed_copper_chest": "Peti Tembaga Terekspos",
  "block.minecraft.exposed_copper_door": "Pintu Tembaga Terekspos",
  "block.minecraft.exposed_copper_golem_statue": "Patung Golem Tembaga Terekspos",
  "block.minecraft.exposed_copper_grate": "Kisi-Kisi Tembaga Terekspos",
  "block.minecraft.exposed_copper_lantern": "Lentera Tembaga Terekspos",
  "block.minecraft.exposed_copper_trapdoor": "Pintu Kolong Tembaga Terekspos",
  "block.minecraft.exposed_cut_copper": "Tembaga Potongan Terekspos",
  "block.minecraft.exposed_cut_copper_slab": "Lempeng Tembaga Potongan Terekspos",
  "block.minecraft.exposed_cut_copper_stairs": "Tangga Tembaga Potongan Terekspos",
  "block.minecraft.exposed_lightning_rod": "Penangkal Petir Terekspos",
  "block.minecraft.farmland": "Tanah Garapan",
  "block.minecraft.fern": "Pakis",
  "block.minecraft.fire": "Api",
  "block.minecraft.fire_coral": "Karang Api",
  "block.minecraft.fire_coral_block": "Balok Karang Api",
  "block.minecraft.fire_coral_fan": "Kipas Laut Api",
  "block.minecraft.fire_coral_wall_fan": "Kipas Laut Api Dinding",
  "block.minecraft.firefly_bush": "Semak Kunang-Kunang",
  "block.minecraft.fletching_table": "Meja Pembuatan Panah",
  "block.minecraft.flower_pot": "Pot Bunga",
  "block.minecraft.flowering_azalea": "Azalea Berbunga",
  "block.minecraft.flowering_azalea_leaves": "Daun Azalea Berbunga",
  "block.minecraft.frogspawn": "Telur Katak",
  "block.minecraft.frosted_ice": "Es Buram",
  "block.minecraft.furnace": "Tungku",
  "block.minecraft.gilded_blackstone": "Batu Hitam Bersepuh",
  "block.minecraft.glass": "Kaca",
  "block.minecraft.glass_pane": "Panel Kaca",
  "block.minecraft.glow_lichen": "Lumut Kerak Sinar",
  "block.minecraft.glowstone": "Batu Sinar",
  "block.minecraft.gold_block": "Balok Emas",
  "block.minecraft.gold_ore": "Bijih Emas",
  "block.minecraft.golden_dandelion": "Randa Tapak Emas",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Lempeng Granit",
  "block.minecraft.granite_stairs": "Tangga Granit",
  "block.minecraft.granite_wall": "Tembok Granit",
  "block.minecraft.grass": "Rumput",
  "block.minecraft.grass_block": "Balok Rumput",
  "block.minecraft.gravel": "Kerikil",
  "block.minecraft.gray_banner": "Panji Abu-Abu",
  "block.minecraft.gray_bed": "Tempat Tidur Abu-Abu",
  "block.minecraft.gray_candle": "Lilin Abu-Abu",
  "block.minecraft.gray_candle_cake": "Kue dengan Lilin Abu-Abu",
  "block.minecraft.gray_carpet": "Karpet Abu-Abu",
  "block.minecraft.gray_concrete": "Beton Abu-Abu",
  "block.minecraft.gray_concrete_powder": "Semen Abu-Abu",
  "block.minecraft.gray_glazed_terracotta": "Terakota Berglasir Abu-Abu",
  "block.minecraft.gray_shulker_box": "Kotak Shulker Abu-Abu",
  "block.minecraft.gray_stained_glass": "Kaca Berwarna Abu-Abu",
  "block.minecraft.gray_stained_glass_pane": "Panel Kaca Berwarna Abu-Abu",
  "block.minecraft.gray_terracotta": "Terakota Abu-Abu",
  "block.minecraft.gray_wool": "Wol Abu-Abu",
  "block.minecraft.green_banner": "Panji Hijau",
  "block.minecraft.green_bed": "Tempat Tidur Hijau",
  "block.minecraft.green_candle": "Lilin Hijau",
  "block.minecraft.green_candle_cake": "Kue dengan Lilin Hijau",
  "block.minecraft.green_carpet": "Karpet Hijau",
  "block.minecraft.green_concrete": "Beton Hijau",
  "block.minecraft.green_concrete_powder": "Semen Hijau",
  "block.minecraft.green_glazed_terracotta": "Terakota Berglasir Hijau",
  "block.minecraft.green_shulker_box": "Kotak Shulker Hijau",
  "block.minecraft.green_stained_glass": "Kaca Berwarna Hijau",
  "block.minecraft.green_stained_glass_pane": "Panel Kaca Berwarna Hijau",
  "block.minecraft.green_terracotta": "Terakota Hijau",
  "block.minecraft.green_wool": "Wol Hijau",
  "block.minecraft.grindstone": "Gerinda",
  "block.minecraft.hanging_roots": "Akar Gantung",
  "block.minecraft.hay_block": "Jerami",
  "block.minecraft.heavy_core": "Inti Berat",
  "block.minecraft.heavy_weighted_pressure_plate": "Pelat Penekan Berat",
  "block.minecraft.honey_block": "Balok Madu",
  "block.minecraft.honeycomb_block": "Balok Sarang Madu",
  "block.minecraft.hopper": "Corong",
  "block.minecraft.horn_coral": "Karang Tanduk",
  "block.minecraft.horn_coral_block": "Balok Karang Tanduk",
  "block.minecraft.horn_coral_fan": "Kipas Laut Tanduk",
  "block.minecraft.horn_coral_wall_fan": "Kipas Laut Tanduk Dinding",
  "block.minecraft.ice": "Es",
  "block.minecraft.infested_chiseled_stone_bricks": "Bata Batu Pahatan Berhama",
  "block.minecraft.infested_cobblestone": "Batu Kasar Berhama",
  "block.minecraft.infested_cracked_stone_bricks": "Bata Batu Retak Berhama",
  "block.minecraft.infested_deepslate": "Batu Sabak Berhama",
  "block.minecraft.infested_mossy_stone_bricks": "Bata Batu Berlumut Berhama",
  "block.minecraft.infested_stone": "Batu Berhama",
  "block.minecraft.infested_stone_bricks": "Bata Batu Berhama",
  "block.minecraft.iron_bars": "Jeruji Besi",
  "block.minecraft.iron_block": "Balok Besi",
  "block.minecraft.iron_chain": "Rantai Besi",
  "block.minecraft.iron_door": "Pintu Besi",
  "block.minecraft.iron_ore": "Bijih Besi",
  "block.minecraft.iron_trapdoor": "Pintu Kolong Besi",
  "block.minecraft.jack_o_lantern": "Lentera Labu",
  "block.minecraft.jigsaw": "Balok Keping",
  "block.minecraft.jukebox": "Kotak Lagu",
  "block.minecraft.jungle_button": "Tombol Rimba",
  "block.minecraft.jungle_door": "Pintu Rimba",
  "block.minecraft.jungle_fence": "Pagar Rimba",
  "block.minecraft.jungle_fence_gate": "Pintu Pagar Rimba",
  "block.minecraft.jungle_hanging_sign": "Papan Tanda Gantung Rimba",
  "block.minecraft.jungle_leaves": "Daun Rimba",
  "block.minecraft.jungle_log": "Gelondong Rimba",
  "block.minecraft.jungle_planks": "Papan Rimba",
  "block.minecraft.jungle_pressure_plate": "Pelat Penekan Rimba",
  "block.minecraft.jungle_sapling": "Bibit Pohon Rimba",
  "block.minecraft.jungle_shelf": "Rak Rimba",
  "block.minecraft.jungle_sign": "Papan Tanda Rimba",
  "block.minecraft.jungle_slab": "Lempeng Rimba",
  "block.minecraft.jungle_stairs": "Tangga Rimba",
  "block.minecraft.jungle_trapdoor": "Pintu Kolong Rimba",
  "block.minecraft.jungle_wall_hanging_sign": "Papan Tanda Gantung Dinding Rimba",
  "block.minecraft.jungle_wall_sign": "Papan Tanda Dinding Rimba",
  "block.minecraft.jungle_wood": "Kayu Rimba",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Tanaman Kelp",
  "block.minecraft.ladder": "Tangga",
  "block.minecraft.lantern": "Lentera",
  "block.minecraft.lapis_block": "Balok Lazuardi",
  "block.minecraft.lapis_ore": "Bijih Lazuardi",
  "block.minecraft.large_amethyst_bud": "Kuncup Kecubung Besar",
  "block.minecraft.large_fern": "Pakis Besar",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kuali Lava",
  "block.minecraft.leaf_litter": "Daun Kering",
  "block.minecraft.lectern": "Podium",
  "block.minecraft.lever": "Tuas",
  "block.minecraft.light": "Cahaya",
  "block.minecraft.light_blue_banner": "Panji Biru Muda",
  "block.minecraft.light_blue_bed": "Tempat Tidur Biru Muda",
  "block.minecraft.light_blue_candle": "Lilin Biru Muda",
  "block.minecraft.light_blue_candle_cake": "Kue dengan Lilin Biru Muda",
  "block.minecraft.light_blue_carpet": "Karpet Biru Muda",
  "block.minecraft.light_blue_concrete": "Beton Biru Muda",
  "block.minecraft.light_blue_concrete_powder": "Semen Biru Muda",
  "block.minecraft.light_blue_glazed_terracotta": "Terakota Berglasir Biru Muda",
  "block.minecraft.light_blue_shulker_box": "Kotak Shulker Biru Muda",
  "block.minecraft.light_blue_stained_glass": "Kaca Berwarna Biru Muda",
  "block.minecraft.light_blue_stained_glass_pane": "Panel Kaca Berwarna Biru Muda",
  "block.minecraft.light_blue_terracotta": "Terakota Biru Muda",
  "block.minecraft.light_blue_wool": "Wol Biru Muda",
  "block.minecraft.light_gray_banner": "Panji Abu-Abu Muda",
  "block.minecraft.light_gray_bed": "Tempat Tidur Abu-Abu Muda",
  "block.minecraft.light_gray_candle": "Lilin Abu-Abu Muda",
  "block.minecraft.light_gray_candle_cake": "Kue dengan Lilin Abu-Abu Muda",
  "block.minecraft.light_gray_carpet": "Karpet Abu-Abu Muda",
  "block.minecraft.light_gray_concrete": "Beton Abu-Abu Muda",
  "block.minecraft.light_gray_concrete_powder": "Semen Abu-Abu Muda",
  "block.minecraft.light_gray_glazed_terracotta": "Terakota Berglasir Abu-Abu Muda",
  "block.minecraft.light_gray_shulker_box": "Kotak Shulker Abu-Abu Muda",
  "block.minecraft.light_gray_stained_glass": "Kaca Berwarna Abu-Abu Muda",
  "block.minecraft.light_gray_stained_glass_pane": "Panel Kaca Berwarna Abu-Abu Muda",
  "block.minecraft.light_gray_terracotta": "Terakota Abu-Abu Muda",
  "block.minecraft.light_gray_wool": "Wol Abu-Abu Muda",
  "block.minecraft.light_weighted_pressure_plate": "Pelat Penekan Ringan",
  "block.minecraft.lightning_rod": "Penangkal Petir",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Lili Lembah",
  "block.minecraft.lily_pad": "Daun Lili Air",
  "block.minecraft.lime_banner": "Panji Hijau Pupus",
  "block.minecraft.lime_bed": "Tempat Tidur Hijau Pupus",
  "block.minecraft.lime_candle": "Lilin Hijau Pupus",
  "block.minecraft.lime_candle_cake": "Kue dengan Lilin Hijau Pupus",
  "block.minecraft.lime_carpet": "Karpet Hijau Pupus",
  "block.minecraft.lime_concrete": "Beton Hijau Pupus",
  "block.minecraft.lime_concrete_powder": "Semen Hijau Pupus",
  "block.minecraft.lime_glazed_terracotta": "Terakota Berglasir Hijau Pupus",
  "block.minecraft.lime_shulker_box": "Kotak Shulker Hijau Pupus",
  "block.minecraft.lime_stained_glass": "Kaca Berwarna Hijau Pupus",
  "block.minecraft.lime_stained_glass_pane": "Panel Kaca Berwarna Hijau Pupus",
  "block.minecraft.lime_terracotta": "Terakota Hijau Pupus",
  "block.minecraft.lime_wool": "Wol Hijau Pupus",
  "block.minecraft.lodestone": "Batu Magnet",
  "block.minecraft.loom": "Alat Tenun",
  "block.minecraft.magenta_banner": "Panji Magenta",
  "block.minecraft.magenta_bed": "Tempat Tidur Magenta",
  "block.minecraft.magenta_candle": "Lilin Magenta",
  "block.minecraft.magenta_candle_cake": "Kue dengan Lilin Magenta",
  "block.minecraft.magenta_carpet": "Karpet Magenta",
  "block.minecraft.magenta_concrete": "Beton Magenta",
  "block.minecraft.magenta_concrete_powder": "Semen Magenta",
  "block.minecraft.magenta_glazed_terracotta": "Terakota Berglasir Magenta",
  "block.minecraft.magenta_shulker_box": "Kotak Shulker Magenta",
  "block.minecraft.magenta_stained_glass": "Kaca Berwarna Magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel Kaca Berwarna Magenta",
  "block.minecraft.magenta_terracotta": "Terakota Magenta",
  "block.minecraft.magenta_wool": "Wol Magenta",
  "block.minecraft.magma_block": "Balok Magma",
  "block.minecraft.mangrove_button": "Tombol Bakau",
  "block.minecraft.mangrove_door": "Pintu Bakau",
  "block.minecraft.mangrove_fence": "Pagar Bakau",
  "block.minecraft.mangrove_fence_gate": "Pintu Pagar Bakau",
  "block.minecraft.mangrove_hanging_sign": "Papan Tanda Gantung Bakau",
  "block.minecraft.mangrove_leaves": "Daun Bakau",
  "block.minecraft.mangrove_log": "Gelondong Bakau",
  "block.minecraft.mangrove_planks": "Papan Bakau",
  "block.minecraft.mangrove_pressure_plate": "Pelat Penekan Bakau",
  "block.minecraft.mangrove_propagule": "Propagul Bakau",
  "block.minecraft.mangrove_roots": "Akar Bakau",
  "block.minecraft.mangrove_shelf": "Rak Bakau",
  "block.minecraft.mangrove_sign": "Papan Tanda Bakau",
  "block.minecraft.mangrove_slab": "Lempeng Bakau",
  "block.minecraft.mangrove_stairs": "Tangga Bakau",
  "block.minecraft.mangrove_trapdoor": "Pintu Kolong Bakau",
  "block.minecraft.mangrove_wall_hanging_sign": "Papan Tanda Gantung Dinding Bakau",
  "block.minecraft.mangrove_wall_sign": "Papan Tanda Dinding Bakau",
  "block.minecraft.mangrove_wood": "Kayu Bakau",
  "block.minecraft.medium_amethyst_bud": "Kuncup Kecubung Sedang",
  "block.minecraft.melon": "Semangka",
  "block.minecraft.melon_stem": "Batang Semangka",
  "block.minecraft.moss_block": "Balok Lumut",
  "block.minecraft.moss_carpet": "Hamparan Lumut",
  "block.minecraft.mossy_cobblestone": "Batu Kasar Berlumut",
  "block.minecraft.mossy_cobblestone_slab": "Lempeng Batu Kasar Berlumut",
  "block.minecraft.mossy_cobblestone_stairs": "Tangga Batu Kasar Berlumut",
  "block.minecraft.mossy_cobblestone_wall": "Tembok Batu Kasar Berlumut",
  "block.minecraft.mossy_stone_brick_slab": "Lempeng Bata Batu Berlumut",
  "block.minecraft.mossy_stone_brick_stairs": "Tangga Bata Batu Berlumut",
  "block.minecraft.mossy_stone_brick_wall": "Tembok Bata Batu Berlumut",
  "block.minecraft.mossy_stone_bricks": "Bata Batu Berlumut",
  "block.minecraft.moving_piston": "Piston Bergerak",
  "block.minecraft.mud": "Lumpur",
  "block.minecraft.mud_brick_slab": "Lempeng Bata Lumpur",
  "block.minecraft.mud_brick_stairs": "Tangga Bata Lumpur",
  "block.minecraft.mud_brick_wall": "Tembok Bata Lumpur",
  "block.minecraft.mud_bricks": "Bata Lumpur",
  "block.minecraft.muddy_mangrove_roots": "Akar Bakau Berlumpur",
  "block.minecraft.mushroom_stem": "Batang Jamur",
  "block.minecraft.mycelium": "Miselium",
  "block.minecraft.nether_brick_fence": "Pagar Bata Nether",
  "block.minecraft.nether_brick_slab": "Lempeng Bata Nether",
  "block.minecraft.nether_brick_stairs": "Tangga Bata Nether",
  "block.minecraft.nether_brick_wall": "Tembok Bata Nether",
  "block.minecraft.nether_bricks": "Balok Bata Nether",
  "block.minecraft.nether_gold_ore": "Bijih Emas Nether",
  "block.minecraft.nether_portal": "Gerbang Nether",
  "block.minecraft.nether_quartz_ore": "Bijih Kuarsa Nether",
  "block.minecraft.nether_sprouts": "Kecambah Nether",
  "block.minecraft.nether_wart": "Ketuat Nether",
  "block.minecraft.nether_wart_block": "Balok Ketuat Nether",
  "block.minecraft.netherite_block": "Balok Netherit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Kotak Nada",
  "block.minecraft.oak_button": "Tombol Ek",
  "block.minecraft.oak_door": "Pintu Ek",
  "block.minecraft.oak_fence": "Pagar Ek",
  "block.minecraft.oak_fence_gate": "Pintu Pagar Ek",
  "block.minecraft.oak_hanging_sign": "Papan Tanda Gantung Ek",
  "block.minecraft.oak_leaves": "Daun Ek",
  "block.minecraft.oak_log": "Gelondong Ek",
  "block.minecraft.oak_planks": "Papan Ek",
  "block.minecraft.oak_pressure_plate": "Pelat Penekan Ek",
  "block.minecraft.oak_sapling": "Bibit Ek",
  "block.minecraft.oak_shelf": "Rak Ek",
  "block.minecraft.oak_sign": "Papan Tanda Ek",
  "block.minecraft.oak_slab": "Lempeng Ek",
  "block.minecraft.oak_stairs": "Tangga Ek",
  "block.minecraft.oak_trapdoor": "Pintu Kolong Ek",
  "block.minecraft.oak_wall_hanging_sign": "Papan Tanda Gantung Dinding Ek",
  "block.minecraft.oak_wall_sign": "Papan Tanda Dinding Ek",
  "block.minecraft.oak_wood": "Kayu Ek",
  "block.minecraft.observer": "Pengamat",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Lampu Katak Hartal",
  "block.minecraft.ominous_banner": "Panji Mengerikan",
  "block.minecraft.open_eyeblossom": "Bunga Mata Terbuka",
  "block.minecraft.orange_banner": "Panji Jingga",
  "block.minecraft.orange_bed": "Tempat Tidur Jingga",
  "block.minecraft.orange_candle": "Lilin Jingga",
  "block.minecraft.orange_candle_cake": "Kue dengan Lilin Jingga",
  "block.minecraft.orange_carpet": "Karpet Jinnga",
  "block.minecraft.orange_concrete": "Beton Jingga",
  "block.minecraft.orange_concrete_powder": "Semen Jingga",
  "block.minecraft.orange_glazed_terracotta": "Terakota Berglasir Jingga",
  "block.minecraft.orange_shulker_box": "Kotak Shulker Jingga",
  "block.minecraft.orange_stained_glass": "Kaca Berwarna Jingga",
  "block.minecraft.orange_stained_glass_pane": "Panel Kaca Berwarna Jingga",
  "block.minecraft.orange_terracotta": "Terakota Jingga",
  "block.minecraft.orange_tulip": "Tulip Jingga",
  "block.minecraft.orange_wool": "Wol Jingga",
  "block.minecraft.oxeye_daisy": "Margrit",
  "block.minecraft.oxidized_chiseled_copper": "Tembaga Pahatan Teroksidasi",
  "block.minecraft.oxidized_copper": "Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_bars": "Jeruji Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_bulb": "Lampu Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_chain": "Rantai Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_chest": "Peti Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_door": "Pintu Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_golem_statue": "Patung Golem Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_grate": "Kisi-Kisi Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_lantern": "Lentera Tembaga Teroksidasi",
  "block.minecraft.oxidized_copper_trapdoor": "Pintu Kolong Tembaga Teroksidasi",
  "block.minecraft.oxidized_cut_copper": "Tembaga Potongan Teroksidasi",
  "block.minecraft.oxidized_cut_copper_slab": "Lempeng Tembaga Potongan Teroksidasi",
  "block.minecraft.oxidized_cut_copper_stairs": "Tangga Tembaga Potongan Teroksidasi",
  "block.minecraft.oxidized_lightning_rod": "Penangkal Petir Teroksidasi",
  "block.minecraft.packed_ice": "Es Padat",
  "block.minecraft.packed_mud": "Lumpur Padat",
  "block.minecraft.pale_hanging_moss": "Lumut Pucat Gantung",
  "block.minecraft.pale_moss_block": "Balok Lumut Pucat",
  "block.minecraft.pale_moss_carpet": "Hamparan Lumut Pucat",
  "block.minecraft.pale_oak_button": "Tombol Ek Pucat",
  "block.minecraft.pale_oak_door": "Pintu Ek Pucat",
  "block.minecraft.pale_oak_fence": "Pagar Ek Pucat",
  "block.minecraft.pale_oak_fence_gate": "Pintu Pagar Ek Pucat",
  "block.minecraft.pale_oak_hanging_sign": "Papan Tanda Gantung Ek Pucat",
  "block.minecraft.pale_oak_leaves": "Daun Ek Pucat",
  "block.minecraft.pale_oak_log": "Gelondong Ek Pucat",
  "block.minecraft.pale_oak_planks": "Papan Ek Pucat",
  "block.minecraft.pale_oak_pressure_plate": "Pelat Penekan Ek Pucat",
  "block.minecraft.pale_oak_sapling": "Bibit Ek Pucat",
  "block.minecraft.pale_oak_shelf": "Rak Ek Pucat",
  "block.minecraft.pale_oak_sign": "Papan Tanda Ek Pucat",
  "block.minecraft.pale_oak_slab": "Lempeng Ek Pucat",
  "block.minecraft.pale_oak_stairs": "Tangga Ek Pucat",
  "block.minecraft.pale_oak_trapdoor": "Pintu Kolong Ek Pucat",
  "block.minecraft.pale_oak_wall_hanging_sign": "Papan Tanda Gantung Dinding Ek Pucat",
  "block.minecraft.pale_oak_wall_sign": "Papan Tanda Dinding Ek Pucat",
  "block.minecraft.pale_oak_wood": "Kayu Ek Pucat",
  "block.minecraft.pearlescent_froglight": "Lampu Katak Gemerlap",
  "block.minecraft.peony": "Peoni",
  "block.minecraft.petrified_oak_slab": "Lempeng Ek Membatu",
  "block.minecraft.piglin_head": "Kepala Piglin",
  "block.minecraft.piglin_wall_head": "Kepala Dinding Piglin",
  "block.minecraft.pink_banner": "Panji Merah Muda",
  "block.minecraft.pink_bed": "Tempat Tidur Merah Muda",
  "block.minecraft.pink_candle": "Lilin Merah Muda",
  "block.minecraft.pink_candle_cake": "Kue dengan Lilin Merah Muda",
  "block.minecraft.pink_carpet": "Karpet Merah Muda",
  "block.minecraft.pink_concrete": "Beton Merah Muda",
  "block.minecraft.pink_concrete_powder": "Semen Merah Muda",
  "block.minecraft.pink_glazed_terracotta": "Terakota Berglasir Merah Muda",
  "block.minecraft.pink_petals": "Mahkota Merah Muda",
  "block.minecraft.pink_shulker_box": "Kotak Shulker Merah Muda",
  "block.minecraft.pink_stained_glass": "Kaca Berwarna Merah Muda",
  "block.minecraft.pink_stained_glass_pane": "Panel Kaca Berwarna Merah Muda",
  "block.minecraft.pink_terracotta": "Terakota Merah Muda",
  "block.minecraft.pink_tulip": "Tulip Merah Muda",
  "block.minecraft.pink_wool": "Wol Merah Muda",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Kepala Piston",
  "block.minecraft.pitcher_crop": "Tanaman Kantong Semar",
  "block.minecraft.pitcher_plant": "Kantong Semar",
  "block.minecraft.player_head": "Kepala Pemain",
  "block.minecraft.player_head.named": "Kepala %s",
  "block.minecraft.player_wall_head": "Kepala Dinding Pemain",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Batu Tetes Runcing",
  "block.minecraft.polished_andesite": "Andesit Gilap",
  "block.minecraft.polished_andesite_slab": "Lempeng Andesit Gilap",
  "block.minecraft.polished_andesite_stairs": "Tangga Andesit Gilap",
  "block.minecraft.polished_basalt": "Basal Gilap",
  "block.minecraft.polished_blackstone": "Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_brick_slab": "Lempeng Bata Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_brick_stairs": "Tangga Bata Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_brick_wall": "Tembok Bata Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_bricks": "Bata Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_button": "Tombol Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_pressure_plate": "Pelat Penekan Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_slab": "Lempeng Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_stairs": "Tangga Batu Hitam Gilap",
  "block.minecraft.polished_blackstone_wall": "Tembok Batu Hitam Gilap",
  "block.minecraft.polished_deepslate": "Batu Sabak Gilap",
  "block.minecraft.polished_deepslate_slab": "Lempeng Batu Sabak Gilap",
  "block.minecraft.polished_deepslate_stairs": "Tangga Batu Sabak Gilap",
  "block.minecraft.polished_deepslate_wall": "Tembok Batu Sabak Gilap",
  "block.minecraft.polished_diorite": "Diorit Gilap",
  "block.minecraft.polished_diorite_slab": "Lempeng Diorit Gilap",
  "block.minecraft.polished_diorite_stairs": "Tangga Diorit Gilap",
  "block.minecraft.polished_granite": "Granit Gilap",
  "block.minecraft.polished_granite_slab": "Lempeng Granit Gilap",
  "block.minecraft.polished_granite_stairs": "Tangga Granit Gilap",
  "block.minecraft.polished_tuff": "Tuf Gilap",
  "block.minecraft.polished_tuff_slab": "Lempeng Tuf Gilap",
  "block.minecraft.polished_tuff_stairs": "Tangga Tuf Gilap",
  "block.minecraft.polished_tuff_wall": "Tembok Tuf Gilap",
  "block.minecraft.poppy": "Popi",
  "block.minecraft.potatoes": "Kentang",
  "block.minecraft.potted_acacia_sapling": "Bibit Akasia Pot",
  "block.minecraft.potted_allium": "Bunga Bawang Pot",
  "block.minecraft.potted_azalea_bush": "Azalea Pot",
  "block.minecraft.potted_azure_bluet": "Azure Bluet Pot",
  "block.minecraft.potted_bamboo": "Bambu Pot",
  "block.minecraft.potted_birch_sapling": "Bibit Betula Pot",
  "block.minecraft.potted_blue_orchid": "Anggrek Biru Pot",
  "block.minecraft.potted_brown_mushroom": "Jamur Cokelat Pot",
  "block.minecraft.potted_cactus": "Kaktus Pot",
  "block.minecraft.potted_cherry_sapling": "Bibit Ceri Pot",
  "block.minecraft.potted_closed_eyeblossom": "Bunga Mata Tertutup Pot",
  "block.minecraft.potted_cornflower": "Bunga Jagung Pot",
  "block.minecraft.potted_crimson_fungus": "Jamur Kirmizi Pot",
  "block.minecraft.potted_crimson_roots": "Akar Kirmizi Pot",
  "block.minecraft.potted_dandelion": "Randa Tapak Pot",
  "block.minecraft.potted_dark_oak_sapling": "Bibit Ek Gelap Pot",
  "block.minecraft.potted_dead_bush": "Semak Mati Pot",
  "block.minecraft.potted_fern": "Pakis Pot",
  "block.minecraft.potted_flowering_azalea_bush": "Azalea Berbunga Pot",
  "block.minecraft.potted_golden_dandelion": "Randa Tapak Emas Pot",
  "block.minecraft.potted_jungle_sapling": "Bibit Pohon Rimba Pot",
  "block.minecraft.potted_lily_of_the_valley": "Lili Lembah Pot",
  "block.minecraft.potted_mangrove_propagule": "Propagul Bakau Pot",
  "block.minecraft.potted_oak_sapling": "Bibit Ek Pot",
  "block.minecraft.potted_open_eyeblossom": "Bunga Mata Terbuka Pot",
  "block.minecraft.potted_orange_tulip": "Tulip Jingga Pot",
  "block.minecraft.potted_oxeye_daisy": "Margrit Pot",
  "block.minecraft.potted_pale_oak_sapling": "Bibit Ek Pucat Pot",
  "block.minecraft.potted_pink_tulip": "Tulip Merah Muda Pot",
  "block.minecraft.potted_poppy": "Popi Pot",
  "block.minecraft.potted_red_mushroom": "Jamur Merah Pot",
  "block.minecraft.potted_red_tulip": "Tulip Merah Pot",
  "block.minecraft.potted_spruce_sapling": "Bibit Cemara Pot",
  "block.minecraft.potted_torchflower": "Bunga Obor Pot",
  "block.minecraft.potted_warped_fungus": "Jamur Kerukut Pot",
  "block.minecraft.potted_warped_roots": "Akar Kerukut Pot",
  "block.minecraft.potted_white_tulip": "Tulip Putih Pot",
  "block.minecraft.potted_wither_rose": "Mawar Wither Pot",
  "block.minecraft.powder_snow": "Salju Bubuk",
  "block.minecraft.powder_snow_cauldron": "Kuali Saju Bubuk",
  "block.minecraft.powered_rail": "Rel Berdaya",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Lempeng Bata Prismarine",
  "block.minecraft.prismarine_brick_stairs": "Tangga Bata Prismarine",
  "block.minecraft.prismarine_bricks": "Bata Prismarine",
  "block.minecraft.prismarine_slab": "Lempeng Prismarine",
  "block.minecraft.prismarine_stairs": "Tangga Prismarine",
  "block.minecraft.prismarine_wall": "Tembok Prismarine",
  "block.minecraft.pumpkin": "Labu",
  "block.minecraft.pumpkin_stem": "Batang Labu",
  "block.minecraft.purple_banner": "Panji Ungu",
  "block.minecraft.purple_bed": "Tempat Tidur Ungu",
  "block.minecraft.purple_candle": "Lilin Ungu",
  "block.minecraft.purple_candle_cake": "Kue dengan Lilin Ungu",
  "block.minecraft.purple_carpet": "Karpet Ungu",
  "block.minecraft.purple_concrete": "Beton Ungu",
  "block.minecraft.purple_concrete_powder": "Semen Ungu",
  "block.minecraft.purple_glazed_terracotta": "Terakota Berglasir Ungu",
  "block.minecraft.purple_shulker_box": "Kotak Shulker Ungu",
  "block.minecraft.purple_stained_glass": "Kaca Berwarna Ungu",
  "block.minecraft.purple_stained_glass_pane": "Panel Kaca Berwarna Ungu",
  "block.minecraft.purple_terracotta": "Terakota Ungu",
  "block.minecraft.purple_wool": "Wol Ungu",
  "block.minecraft.purpur_block": "Balok Purpur",
  "block.minecraft.purpur_pillar": "Pilar Purpur",
  "block.minecraft.purpur_slab": "Lempeng Purpur",
  "block.minecraft.purpur_stairs": "Tangga Purpur",
  "block.minecraft.quartz_block": "Balok Kuarsa",
  "block.minecraft.quartz_bricks": "Bata Kuarsa",
  "block.minecraft.quartz_pillar": "Pilar Kuarsa",
  "block.minecraft.quartz_slab": "Lempeng Kuarsa",
  "block.minecraft.quartz_stairs": "Tangga Kuarsa",
  "block.minecraft.rail": "Rel",
  "block.minecraft.raw_copper_block": "Balok Tembaga Mentah",
  "block.minecraft.raw_gold_block": "Balok Emas Mentah",
  "block.minecraft.raw_iron_block": "Balok Besi Mentah",
  "block.minecraft.red_banner": "Panji Merah",
  "block.minecraft.red_bed": "Tempat Tidur Merah",
  "block.minecraft.red_candle": "Lilin Merah",
  "block.minecraft.red_candle_cake": "Kue dengan Lilin Merah",
  "block.minecraft.red_carpet": "Karpet Merah",
  "block.minecraft.red_concrete": "Beton Merah",
  "block.minecraft.red_concrete_powder": "Semen Merah",
  "block.minecraft.red_glazed_terracotta": "Terakota Berglasir Merah",
  "block.minecraft.red_mushroom": "Jamur Merah",
  "block.minecraft.red_mushroom_block": "Balok Jamur Merah",
  "block.minecraft.red_nether_brick_slab": "Lempeng Bata Nether Merah",
  "block.minecraft.red_nether_brick_stairs": "Tangga Bata Nether Merah",
  "block.minecraft.red_nether_brick_wall": "Tembok Bata Nether Merah",
  "block.minecraft.red_nether_bricks": "Bata Nether Merah",
  "block.minecraft.red_sand": "Pasir Merah",
  "block.minecraft.red_sandstone": "Batu Pasir Merah",
  "block.minecraft.red_sandstone_slab": "Lempeng Batu Pasir Merah",
  "block.minecraft.red_sandstone_stairs": "Tangga Batu Pasir Merah",
  "block.minecraft.red_sandstone_wall": "Tembok Batu Pasir Merah",
  "block.minecraft.red_shulker_box": "Kotak Shulker Merah",
  "block.minecraft.red_stained_glass": "Kaca Berwarna Merah",
  "block.minecraft.red_stained_glass_pane": "Panel Kaca Berwarna Merah",
  "block.minecraft.red_terracotta": "Terakota Merah",
  "block.minecraft.red_tulip": "Tulip Merah",
  "block.minecraft.red_wool": "Wol Merah",
  "block.minecraft.redstone_block": "Balok Redstone",
  "block.minecraft.redstone_lamp": "Lampu Redstone",
  "block.minecraft.redstone_ore": "Bijih Redstone",
  "block.minecraft.redstone_torch": "Obor Redstone",
  "block.minecraft.redstone_wall_torch": "Obor Dinding Redstone",
  "block.minecraft.redstone_wire": "Kabel Redstone",
  "block.minecraft.reinforced_deepslate": "Batu Sabak Diperkokoh",
  "block.minecraft.repeater": "Pengulang Redstone",
  "block.minecraft.repeating_command_block": "Balok Perintah Mengulang",
  "block.minecraft.resin_block": "Balok Resin",
  "block.minecraft.resin_brick_slab": "Lempeng Bata Resin",
  "block.minecraft.resin_brick_stairs": "Tangga Bata Resin",
  "block.minecraft.resin_brick_wall": "Tembok Bata Resin",
  "block.minecraft.resin_bricks": "Balok Bata Resin",
  "block.minecraft.resin_clump": "Gumpalan Resin",
  "block.minecraft.respawn_anchor": "Jangkar Pembangkit",
  "block.minecraft.rooted_dirt": "Tanah Berakar",
  "block.minecraft.rose_bush": "Semak Mawar",
  "block.minecraft.sand": "Pasir",
  "block.minecraft.sandstone": "Batu Pasir",
  "block.minecraft.sandstone_slab": "Lempeng Batu Pasir",
  "block.minecraft.sandstone_stairs": "Tangga Batu Pasir",
  "block.minecraft.sandstone_wall": "Tembok Batu Pasir",
  "block.minecraft.scaffolding": "Perancah",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Katalisator Sculk",
  "block.minecraft.sculk_sensor": "Sensor Sculk",
  "block.minecraft.sculk_shrieker": "Sculk Penjerit",
  "block.minecraft.sculk_vein": "Urat Sculk",
  "block.minecraft.sea_lantern": "Lentera Laut",
  "block.minecraft.sea_pickle": "Acar Laut",
  "block.minecraft.seagrass": "Lamun",
  "block.minecraft.set_spawn": "Titik bangkit ditetapkan",
  "block.minecraft.short_dry_grass": "Rumput Kering Pendek",
  "block.minecraft.short_grass": "Rumput Pendek",
  "block.minecraft.shroomlight": "Lampu Jamur",
  "block.minecraft.shulker_box": "Kotak Shulker",
  "block.minecraft.skeleton_skull": "Tengkorak Bengkarak",
  "block.minecraft.skeleton_wall_skull": "Tengkorak Dinding Bengkarak",
  "block.minecraft.slime_block": "Balok Geladir",
  "block.minecraft.small_amethyst_bud": "Kuncup Kecubung Kecil",
  "block.minecraft.small_dripleaf": "Daun Tetes Kecil",
  "block.minecraft.smithing_table": "Meja Tempa",
  "block.minecraft.smoker": "Pengasap",
  "block.minecraft.smooth_basalt": "Basal Halus",
  "block.minecraft.smooth_quartz": "Balok Kuarsa Halus",
  "block.minecraft.smooth_quartz_slab": "Lempeng Kuarsa Halus",
  "block.minecraft.smooth_quartz_stairs": "Tangga Kuarsa Halus",
  "block.minecraft.smooth_red_sandstone": "Batu Pasir Merah Halus",
  "block.minecraft.smooth_red_sandstone_slab": "Lempeng Batu Pasir Merah Halus",
  "block.minecraft.smooth_red_sandstone_stairs": "Tangga Batu Pasir Merah Halus",
  "block.minecraft.smooth_sandstone": "Batu Pasir Halus",
  "block.minecraft.smooth_sandstone_slab": "Lempeng Batu Pasir Halus",
  "block.minecraft.smooth_sandstone_stairs": "Tangga Batu Pasir Halus",
  "block.minecraft.smooth_stone": "Batu Halus",
  "block.minecraft.smooth_stone_slab": "Lempeng Batu Halus",
  "block.minecraft.sniffer_egg": "Telur Pengendus",
  "block.minecraft.snow": "Salju",
  "block.minecraft.snow_block": "Balok Salju",
  "block.minecraft.soul_campfire": "Api Unggun Jiwa",
  "block.minecraft.soul_fire": "Api Jiwa",
  "block.minecraft.soul_lantern": "Lentera Jiwa",
  "block.minecraft.soul_sand": "Pasir Jiwa",
  "block.minecraft.soul_soil": "Tanah Jiwa",
  "block.minecraft.soul_torch": "Obor Jiwa",
  "block.minecraft.soul_wall_torch": "Obor Dinding Jiwa",
  "block.minecraft.spawn.not_valid": "Tempat tidur atau jangkar pembangkit Anda tidak ada atau terhalang",
  "block.minecraft.spawner": "Pembangkit Monster",
  "block.minecraft.spawner.desc1": "Interaksi dengan Telur Pewujudan:",
  "block.minecraft.spawner.desc2": "Mengatur Jenis Makhluk",
  "block.minecraft.sponge": "Spons",
  "block.minecraft.spore_blossom": "Kembang Spora",
  "block.minecraft.spruce_button": "Tombol Cemara",
  "block.minecraft.spruce_door": "Pintu Cemara",
  "block.minecraft.spruce_fence": "Pagar Cemara",
  "block.minecraft.spruce_fence_gate": "Pintu Pagar Cemara",
  "block.minecraft.spruce_hanging_sign": "Papan Tanda Gantung Cemara",
  "block.minecraft.spruce_leaves": "Daun Cemara",
  "block.minecraft.spruce_log": "Gelondong Cemara",
  "block.minecraft.spruce_planks": "Papan Cemara",
  "block.minecraft.spruce_pressure_plate": "Pelat Penekan Cemara",
  "block.minecraft.spruce_sapling": "Bibit Cemara",
  "block.minecraft.spruce_shelf": "Rak Cemara",
  "block.minecraft.spruce_sign": "Papan Tanda Cemara",
  "block.minecraft.spruce_slab": "Lempeng Cemara",
  "block.minecraft.spruce_stairs": "Tangga Cemara",
  "block.minecraft.spruce_trapdoor": "Pintu Kolong Cemara",
  "block.minecraft.spruce_wall_hanging_sign": "Papan Tanda Gantung Dinding Cemara",
  "block.minecraft.spruce_wall_sign": "Papan Tanda Dinding Cemara",
  "block.minecraft.spruce_wood": "Kayu Cemara",
  "block.minecraft.sticky_piston": "Piston Lengket",
  "block.minecraft.stone": "Batu",
  "block.minecraft.stone_brick_slab": "Lempeng Bata Batu",
  "block.minecraft.stone_brick_stairs": "Tangga Bata Batu",
  "block.minecraft.stone_brick_wall": "Tembok Bata Batu",
  "block.minecraft.stone_bricks": "Bata Batu",
  "block.minecraft.stone_button": "Tombol Batu",
  "block.minecraft.stone_pressure_plate": "Pelat Penekan Batu",
  "block.minecraft.stone_slab": "Lempeng Batu",
  "block.minecraft.stone_stairs": "Tangga Batu",
  "block.minecraft.stonecutter": "Pemahat Batu",
  "block.minecraft.stripped_acacia_log": "Gelondong Akasia Kupas",
  "block.minecraft.stripped_acacia_wood": "Kayu Akasia Kupas",
  "block.minecraft.stripped_bamboo_block": "Balok Bambu Kupas",
  "block.minecraft.stripped_birch_log": "Gelondong Betula Kupas",
  "block.minecraft.stripped_birch_wood": "Kayu Betula Kupas",
  "block.minecraft.stripped_cherry_log": "Gelondong Ceri Kupas",
  "block.minecraft.stripped_cherry_wood": "Kayu Ceri Kupas",
  "block.minecraft.stripped_crimson_hyphae": "Hifa Kirmizi Kupas",
  "block.minecraft.stripped_crimson_stem": "Batang Kirmizi Kupas",
  "block.minecraft.stripped_dark_oak_log": "Gelondong Ek Gelap Kupas",
  "block.minecraft.stripped_dark_oak_wood": "Kayu Ek Gelap Kupas",
  "block.minecraft.stripped_jungle_log": "Gelondong Rimba Kupas",
  "block.minecraft.stripped_jungle_wood": "Kayu Rimba Kupas",
  "block.minecraft.stripped_mangrove_log": "Gelondong Bakau Kupas",
  "block.minecraft.stripped_mangrove_wood": "Kayu Bakau Kupas",
  "block.minecraft.stripped_oak_log": "Gelondong Ek Kupas",
  "block.minecraft.stripped_oak_wood": "Kayu Ek Kupas",
  "block.minecraft.stripped_pale_oak_log": "Gelondong Ek Pucat Kupas",
  "block.minecraft.stripped_pale_oak_wood": "Kayu Ek Pucat Kupas",
  "block.minecraft.stripped_spruce_log": "Gelondong Cemara Kupas",
  "block.minecraft.stripped_spruce_wood": "Kayu Cemara Kupas",
  "block.minecraft.stripped_warped_hyphae": "Hifa Kerukut Kupas",
  "block.minecraft.stripped_warped_stem": "Batang Kerukut Kupas",
  "block.minecraft.structure_block": "Balok Struktur",
  "block.minecraft.structure_void": "Struktur Hampa",
  "block.minecraft.sugar_cane": "Tebu",
  "block.minecraft.sunflower": "Bunga Matahari",
  "block.minecraft.suspicious_gravel": "Kerikil Mencurigakan",
  "block.minecraft.suspicious_sand": "Pasir Mencurigakan",
  "block.minecraft.sweet_berry_bush": "Semak Beri Manis",
  "block.minecraft.tall_dry_grass": "Rumput Kering Tinggi",
  "block.minecraft.tall_grass": "Rumput Tinggi",
  "block.minecraft.tall_seagrass": "Lamun Tinggi",
  "block.minecraft.target": "Sasaran",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Balok Uji",
  "block.minecraft.test_instance_block": "Balok Wujud Uji",
  "block.minecraft.tinted_glass": "Kaca Film",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT diatur tidak dapat meledak",
  "block.minecraft.torch": "Obor",
  "block.minecraft.torchflower": "Bunga Obor",
  "block.minecraft.torchflower_crop": "Tanaman Bunga Obor",
  "block.minecraft.trapped_chest": "Peti Jebakan",
  "block.minecraft.trial_spawner": "Pembangkit Cobaan",
  "block.minecraft.tripwire": "Kawat Senggol",
  "block.minecraft.tripwire_hook": "Pengait Kawat Senggol",
  "block.minecraft.tube_coral": "Karang Pipa",
  "block.minecraft.tube_coral_block": "Balok Karang Pipa",
  "block.minecraft.tube_coral_fan": "Kipas Laut Pipa",
  "block.minecraft.tube_coral_wall_fan": "Kipas Laut Pipa Dinding",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Lempeng Bata Tuf",
  "block.minecraft.tuff_brick_stairs": "Tangga Bata Tuf",
  "block.minecraft.tuff_brick_wall": "Tembok Bata Tuf",
  "block.minecraft.tuff_bricks": "Bata Tuf",
  "block.minecraft.tuff_slab": "Lempeng Tuf",
  "block.minecraft.tuff_stairs": "Tangga Tuf",
  "block.minecraft.tuff_wall": "Tembok Tuf",
  "block.minecraft.turtle_egg": "Telur Penyu",
  "block.minecraft.twisting_vines": "Perambat Melilit",
  "block.minecraft.twisting_vines_plant": "Tanaman Perambat Melilit",
  "block.minecraft.vault": "Brankas",
  "block.minecraft.verdant_froglight": "Lampu Katak Menghijau",
  "block.minecraft.vine": "Tumbuhan Merambat",
  "block.minecraft.void_air": "Udara Hampa",
  "block.minecraft.wall_torch": "Obor Dinding",
  "block.minecraft.warped_button": "Tombol Kerukut",
  "block.minecraft.warped_door": "Pintu Kerukut",
  "block.minecraft.warped_fence": "Pagar Kerukut",
  "block.minecraft.warped_fence_gate": "Pintu Pagar Kerukut",
  "block.minecraft.warped_fungus": "Jamur Kerukut",
  "block.minecraft.warped_hanging_sign": "Papan Tanda Gantung Kerukut",
  "block.minecraft.warped_hyphae": "Hifa Kerukut",
  "block.minecraft.warped_nylium": "Nilium Kerukut",
  "block.minecraft.warped_planks": "Papan Kerukut",
  "block.minecraft.warped_pressure_plate": "Pelat Penekan Kerukut",
  "block.minecraft.warped_roots": "Akar Kerukut",
  "block.minecraft.warped_shelf": "Rak Kerukut",
  "block.minecraft.warped_sign": "Papan Tanda Kerukut",
  "block.minecraft.warped_slab": "Lempeng Kerukut",
  "block.minecraft.warped_stairs": "Tangga Kerukut",
  "block.minecraft.warped_stem": "Batang Kerukut",
  "block.minecraft.warped_trapdoor": "Pintu Kolong Kerukut",
  "block.minecraft.warped_wall_hanging_sign": "Papan Tanda Gantung Dinding Kerukut",
  "block.minecraft.warped_wall_sign": "Papan Tanda Dinding Kerukut",
  "block.minecraft.warped_wart_block": "Balok Ketuat Kerukut",
  "block.minecraft.water": "Air",
  "block.minecraft.water_cauldron": "Kuali Air",
  "block.minecraft.waxed_chiseled_copper": "Tembaga Pahatan Berlilin",
  "block.minecraft.waxed_copper_bars": "Jeruji Tembaga Berlilin",
  "block.minecraft.waxed_copper_block": "Balok Tembaga Berlilin",
  "block.minecraft.waxed_copper_bulb": "Lampu Tembaga Berlilin",
  "block.minecraft.waxed_copper_chain": "Rantai Tembaga Berlilin",
  "block.minecraft.waxed_copper_chest": "Peti Tembaga Berlilin",
  "block.minecraft.waxed_copper_door": "Pintu Tembaga Berlilin",
  "block.minecraft.waxed_copper_golem_statue": "Patung Golem Tembaga Berlilin",
  "block.minecraft.waxed_copper_grate": "Kisi-Kisi Tembaga Berlilin",
  "block.minecraft.waxed_copper_lantern": "Lentera Tembaga Berlilin",
  "block.minecraft.waxed_copper_trapdoor": "Pintu Kolong Tembaga Berlilin",
  "block.minecraft.waxed_cut_copper": "Tembaga Potongan Berlilin",
  "block.minecraft.waxed_cut_copper_slab": "Lempeng Tembaga Potongan Berlilin",
  "block.minecraft.waxed_cut_copper_stairs": "Tangga Tembaga Potongan Berlilin",
  "block.minecraft.waxed_exposed_chiseled_copper": "Tembaga Pahatan Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper": "Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_bars": "Jeruji Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_bulb": "Lampu Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_chain": "Rantai Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_chest": "Peti Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_door": "Pintu Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Patung Golem Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_grate": "Kisi-Kisi Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_lantern": "Lentera Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Pintu Kolong Tembaga Terekspos Berlilin",
  "block.minecraft.waxed_exposed_cut_copper": "Tembaga Potongan Terekspos Berlilin",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Lempeng Tembaga Potongan Terekspos Berlilin",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Tangga Tembaga Potongan Terekspos Berlilin",
  "block.minecraft.waxed_exposed_lightning_rod": "Penangkal Petir Terekspos Berlilin",
  "block.minecraft.waxed_lightning_rod": "Penangkal Petir Berlilin",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Tembaga Pahatan Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper": "Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_bars": "Jeruji Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lampu Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_chain": "Rantai Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_chest": "Peti Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_door": "Pintu Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Patung Golem Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_grate": "Kisi-Kisi Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lentera Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Pintu Kolong Tembaga Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_cut_copper": "Tembaga Potongan Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Lempeng Tembaga Potongan Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Tangga Tembaga Potongan Teroksidasi Berlilin",
  "block.minecraft.waxed_oxidized_lightning_rod": "Penangkal Petir Teroksidasi Berlilin",
  "block.minecraft.waxed_weathered_chiseled_copper": "Tembaga Pahatan Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper": "Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_bars": "Jeruji Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_bulb": "Lampu Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_chain": "Rantai Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_chest": "Peti Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_door": "Pintu Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Patung Golem Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_grate": "Kisi-Kisi Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_lantern": "Lentera Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Pintu Kolong Tembaga Berkarat Berlilin",
  "block.minecraft.waxed_weathered_cut_copper": "Tembaga Potongan Berkarat Berlilin",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Lempeng Tembaga Potongan Berkarat Berlilin",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Tangga Tembaga Potongan Berkarat Berlilin",
  "block.minecraft.waxed_weathered_lightning_rod": "Penangkal Petir Berkarat Berlilin",
  "block.minecraft.weathered_chiseled_copper": "Tembaga Pahatan Berkarat",
  "block.minecraft.weathered_copper": "Tembaga Berkarat",
  "block.minecraft.weathered_copper_bars": "Jeruji Tembaga Berkarat",
  "block.minecraft.weathered_copper_bulb": "Lampu Tembaga Berkarat",
  "block.minecraft.weathered_copper_chain": "Rantai Tembaga Berkarat",
  "block.minecraft.weathered_copper_chest": "Peti Tembaga Berkarat",
  "block.minecraft.weathered_copper_door": "Pintu Tembaga Berkarat",
  "block.minecraft.weathered_copper_golem_statue": "Patung Golem Tembaga Berkarat",
  "block.minecraft.weathered_copper_grate": "Kisi-Kisi Tembaga Berkarat",
  "block.minecraft.weathered_copper_lantern": "Lentera Tembaga Berkarat",
  "block.minecraft.weathered_copper_trapdoor": "Pintu Kolong Tembaga Berkarat",
  "block.minecraft.weathered_cut_copper": "Tembaga Potongan Berkarat",
  "block.minecraft.weathered_cut_copper_slab": "Lempeng Tembaga Potongan Berkarat",
  "block.minecraft.weathered_cut_copper_stairs": "Tangga Tembaga Potongan Berkarat",
  "block.minecraft.weathered_lightning_rod": "Penangkal Petir Berkarat",
  "block.minecraft.weeping_vines": "Perambat Berkulai",
  "block.minecraft.weeping_vines_plant": "Tanaman Perambat Berkulai",
  "block.minecraft.wet_sponge": "Spons Basah",
  "block.minecraft.wheat": "Gandum",
  "block.minecraft.white_banner": "Panji Putih",
  "block.minecraft.white_bed": "Tempat Tidur Putih",
  "block.minecraft.white_candle": "Lilin Putih",
  "block.minecraft.white_candle_cake": "Kue dengan Lilin Putih",
  "block.minecraft.white_carpet": "Karpet Putih",
  "block.minecraft.white_concrete": "Beton Putih",
  "block.minecraft.white_concrete_powder": "Semen Putih",
  "block.minecraft.white_glazed_terracotta": "Terakota Berglasir Putih",
  "block.minecraft.white_shulker_box": "Kotak Shulker Putih",
  "block.minecraft.white_stained_glass": "Kaca Berwarna Putih",
  "block.minecraft.white_stained_glass_pane": "Panel Kaca Berwarna Putih",
  "block.minecraft.white_terracotta": "Terakota Putih",
  "block.minecraft.white_tulip": "Tulip Putih",
  "block.minecraft.white_wool": "Wol Putih",
  "block.minecraft.wildflowers": "Bunga Liar",
  "block.minecraft.wither_rose": "Mawar Wither",
  "block.minecraft.wither_skeleton_skull": "Tengkorak Bengkarak Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Tengkorak Dinding Bengkarak Wither",
  "block.minecraft.yellow_banner": "Panji Kuning",
  "block.minecraft.yellow_bed": "Tempat Tidur Kuning",
  "block.minecraft.yellow_candle": "Lilin Kuning",
  "block.minecraft.yellow_candle_cake": "Kue dengan Lilin Kuning",
  "block.minecraft.yellow_carpet": "Karpet Kuning",
  "block.minecraft.yellow_concrete": "Beton Kuning",
  "block.minecraft.yellow_concrete_powder": "Semen Kuning",
  "block.minecraft.yellow_glazed_terracotta": "Terakota Berglasir Kuning",
  "block.minecraft.yellow_shulker_box": "Kotak Shulker Kuning",
  "block.minecraft.yellow_stained_glass": "Kaca Berwarna Kuning",
  "block.minecraft.yellow_stained_glass_pane": "Panel Kaca Berwarna Kuning",
  "block.minecraft.yellow_terracotta": "Terakota Kuning",
  "block.minecraft.yellow_wool": "Wol Kuning",
  "block.minecraft.zombie_head": "Kepala Zombi",
  "block.minecraft.zombie_wall_head": "Kepala Dinding Zombi",
  "item.minecraft.acacia_boat": "Perahu Akasia",
  "item.minecraft.acacia_chest_boat": "Perahu Akasia dengan Peti",
  "item.minecraft.allay_spawn_egg": "Telur Pewujudan Andaru",
  "item.minecraft.amethyst_shard": "Serpihan Kecubung",
  "item.minecraft.angler_pottery_shard": "Serpihan Pasu Pemancing",
  "item.minecraft.angler_pottery_sherd": "Serpihan Pasu Pemancing",
  "item.minecraft.apple": "Apel",
  "item.minecraft.archer_pottery_shard": "Serpihan Pasu Pemanah",
  "item.minecraft.archer_pottery_sherd": "Serpihan Pasu Pemanah",
  "item.minecraft.armadillo_scute": "Sisik Armadilo",
  "item.minecraft.armadillo_spawn_egg": "Telur Pewujudan Armadilo",
  "item.minecraft.armor_stand": "Cagak Zirah",
  "item.minecraft.arms_up_pottery_shard": "Serpihan Pasu Angkat Tangan",
  "item.minecraft.arms_up_pottery_sherd": "Serpihan Pasu Angkat Tangan",
  "item.minecraft.arrow": "Panah",
  "item.minecraft.axolotl_bucket": "Ember Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Telur Pewujudan Axolotl",
  "item.minecraft.baked_potato": "Kentang Panggang",
  "item.minecraft.bamboo_chest_raft": "Rakit Bambu dengan Peti",
  "item.minecraft.bamboo_raft": "Rakit Bambu",
  "item.minecraft.bat_spawn_egg": "Telur Pewujudan Kelelawar",
  "item.minecraft.bee_spawn_egg": "Telur Pewujudan Lebah",
  "item.minecraft.beef": "Daging Sapi Mentah",
  "item.minecraft.beetroot": "Bit",
  "item.minecraft.beetroot_seeds": "Benih Bit",
  "item.minecraft.beetroot_soup": "Sup Bit",
  "item.minecraft.birch_boat": "Perahu Betula",
  "item.minecraft.birch_chest_boat": "Perahu Betula dengan Peti",
  "item.minecraft.black_bundle": "Kantong Hitam",
  "item.minecraft.black_dye": "Pewarna Hitam",
  "item.minecraft.black_harness": "Rungkup Hitam",
  "item.minecraft.blade_pottery_shard": "Serpihan Pasu Bilah",
  "item.minecraft.blade_pottery_sherd": "Serpihan Pasu Bilah",
  "item.minecraft.blaze_powder": "Bubuk Kemamang",
  "item.minecraft.blaze_rod": "Tongkat Kemamang",
  "item.minecraft.blaze_spawn_egg": "Telur Pewujudan Kemamang",
  "item.minecraft.blue_bundle": "Kantong Biru",
  "item.minecraft.blue_dye": "Pewarna Biru",
  "item.minecraft.blue_egg": "Telur Biru",
  "item.minecraft.blue_harness": "Rungkup Biru",
  "item.minecraft.bogged_spawn_egg": "Telur Pewujudan Lapukan",
  "item.minecraft.bolt_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Trim Zirah Baut",
  "item.minecraft.bone": "Tulang",
  "item.minecraft.bone_meal": "Tepung Tulang",
  "item.minecraft.book": "Buku",
  "item.minecraft.bordure_indented_banner_pattern": "Pola Panji Tepi Bertakik",
  "item.minecraft.bow": "Busur",
  "item.minecraft.bowl": "Mangkuk",
  "item.minecraft.bread": "Roti",
  "item.minecraft.breeze_rod": "Tongkat Pawana",
  "item.minecraft.breeze_spawn_egg": "Telur Pewujudan Pawana",
  "item.minecraft.brewer_pottery_shard": "Serpihan Pasu Peramu",
  "item.minecraft.brewer_pottery_sherd": "Serpihan Pasu Peramu",
  "item.minecraft.brewing_stand": "Alat Peramuan",
  "item.minecraft.brick": "Bata",
  "item.minecraft.brown_bundle": "Kantong Cokelat",
  "item.minecraft.brown_dye": "Pewarna Cokelat",
  "item.minecraft.brown_egg": "Telur Cokelat",
  "item.minecraft.brown_harness": "Rungkup Cokelat",
  "item.minecraft.brush": "Sikat",
  "item.minecraft.bucket": "Ember",
  "item.minecraft.bundle": "Kantong",
  "item.minecraft.bundle.empty": "Kosong",
  "item.minecraft.bundle.empty.description": "Dapat menyimpan tumpukan benda campur",
  "item.minecraft.bundle.full": "Penuh",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Serpihan Pasu Api",
  "item.minecraft.burn_pottery_sherd": "Serpihan Pasu Api",
  "item.minecraft.camel_husk_spawn_egg": "Telur Pewujudan Unta Belulang",
  "item.minecraft.camel_spawn_egg": "Telur Pewujudan Unta",
  "item.minecraft.carrot": "Wortel",
  "item.minecraft.carrot_on_a_stick": "Wortel di Tongkat",
  "item.minecraft.cat_spawn_egg": "Telur Pewujudan Kucing",
  "item.minecraft.cauldron": "Kuali",
  "item.minecraft.cave_spider_spawn_egg": "Telur Pewujudan Laba-Laba Gua",
  "item.minecraft.chainmail_boots": "Sepatu Rantai",
  "item.minecraft.chainmail_chestplate": "Baju Rantai",
  "item.minecraft.chainmail_helmet": "Helm Rantai",
  "item.minecraft.chainmail_leggings": "Celana Rantai",
  "item.minecraft.charcoal": "Arang",
  "item.minecraft.cherry_boat": "Perahu Ceri",
  "item.minecraft.cherry_chest_boat": "Perahu Ceri dengan Peti",
  "item.minecraft.chest_minecart": "Kereta Tambang dengan Peti",
  "item.minecraft.chicken": "Daging Ayam Mentah",
  "item.minecraft.chicken_spawn_egg": "Telur Pewujudan Ayam",
  "item.minecraft.chorus_fruit": "Buah Korus",
  "item.minecraft.clay_ball": "Bola Tanah Liat",
  "item.minecraft.clock": "Jam",
  "item.minecraft.coal": "Batu Bara",
  "item.minecraft.coast_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Trim Zirah Pesisir",
  "item.minecraft.cocoa_beans": "Biji Kakao",
  "item.minecraft.cod": "Kod Mentah",
  "item.minecraft.cod_bucket": "Ember Kod",
  "item.minecraft.cod_spawn_egg": "Telur Pewujudan Kod",
  "item.minecraft.command_block_minecart": "Kereta Tambang dengan Balok Perintah",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Daging Panggang",
  "item.minecraft.cooked_chicken": "Daging Ayam Bakar",
  "item.minecraft.cooked_cod": "Kod Matang",
  "item.minecraft.cooked_mutton": "Daging Domba Matang",
  "item.minecraft.cooked_porkchop": "Daging Babi Matang",
  "item.minecraft.cooked_rabbit": "Daging Kelinci Matang",
  "item.minecraft.cooked_salmon": "Salmon Matang",
  "item.minecraft.cookie": "Biskuit",
  "item.minecraft.copper_axe": "Kapak Tembaga",
  "item.minecraft.copper_boots": "Sepatu Tembaga",
  "item.minecraft.copper_chestplate": "Baju Tembaga",
  "item.minecraft.copper_golem_spawn_egg": "Telur Pewujudan Golem Tembaga",
  "item.minecraft.copper_helmet": "Helm Tembaga",
  "item.minecraft.copper_hoe": "Cangkul Tembaga",
  "item.minecraft.copper_horse_armor": "Zirah Kuda Tembaga",
  "item.minecraft.copper_ingot": "Tembaga Batangan",
  "item.minecraft.copper_leggings": "Celana Tembaga",
  "item.minecraft.copper_nautilus_armor": "Zirah Nautilus Tembaga",
  "item.minecraft.copper_nugget": "Bongkahan Tembaga",
  "item.minecraft.copper_pickaxe": "Beliung Tembaga",
  "item.minecraft.copper_shovel": "Sekop Tembaga",
  "item.minecraft.copper_spear": "Tombak Tembaga",
  "item.minecraft.copper_sword": "Pedang Tembaga",
  "item.minecraft.cow_spawn_egg": "Telur Pewujudan Sapi",
  "item.minecraft.creaking_spawn_egg": "Telur Pewujudan Keriut",
  "item.minecraft.creeper_banner_pattern": "Pola Panji",
  "item.minecraft.creeper_banner_pattern.desc": "Rupa Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Pola Panji Rupa Creeper",
  "item.minecraft.creeper_spawn_egg": "Telur Pewujudan Creeper",
  "item.minecraft.crossbow": "Busur Silang",
  "item.minecraft.crossbow.projectile": "Proyektil:",
  "item.minecraft.crossbow.projectile.multiple": "Proyektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proyektil: %s",
  "item.minecraft.cyan_bundle": "Kantong Sian",
  "item.minecraft.cyan_dye": "Pewarna Sian",
  "item.minecraft.cyan_harness": "Rungkup Sian",
  "item.minecraft.danger_pottery_shard": "Serpihan Pasu Bahaya",
  "item.minecraft.danger_pottery_sherd": "Serpihan Pasu Bahaya",
  "item.minecraft.dark_oak_boat": "Perahu Ek Gelap",
  "item.minecraft.dark_oak_chest_boat": "Perahu Ek Gelap dengan Peti",
  "item.minecraft.debug_stick": "Batang Awakutu",
  "item.minecraft.debug_stick.empty": "%s tidak memiliki sifat",
  "item.minecraft.debug_stick.select": "dipilih \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" -> %s",
  "item.minecraft.diamond": "Berlian",
  "item.minecraft.diamond_axe": "Kapak Berlian",
  "item.minecraft.diamond_boots": "Sepatu Berlian",
  "item.minecraft.diamond_chestplate": "Baju Berlian",
  "item.minecraft.diamond_helmet": "Helm Berlian",
  "item.minecraft.diamond_hoe": "Cangkul Berlian",
  "item.minecraft.diamond_horse_armor": "Zirah Kuda Berlian",
  "item.minecraft.diamond_leggings": "Celana Berlian",
  "item.minecraft.diamond_nautilus_armor": "Zirah Nautilus Berlian",
  "item.minecraft.diamond_pickaxe": "Beliung Berlian",
  "item.minecraft.diamond_shovel": "Sekop Berlian",
  "item.minecraft.diamond_spear": "Tombak Berlian",
  "item.minecraft.diamond_sword": "Pedang Berlian",
  "item.minecraft.disc_fragment_5": "Fragmen Cakram",
  "item.minecraft.disc_fragment_5.desc": "Cakram Musik - 5",
  "item.minecraft.dolphin_spawn_egg": "Telur Pewujudan Lumba-Lumba",
  "item.minecraft.donkey_spawn_egg": "Telur Pewujudan Keledai",
  "item.minecraft.dragon_breath": "Napas Naga",
  "item.minecraft.dried_kelp": "Kelp Kering",
  "item.minecraft.drowned_spawn_egg": "Telur Pewujudan Hanyutan",
  "item.minecraft.dune_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Trim Zirah Gumuk",
  "item.minecraft.echo_shard": "Serpihan Gaung",
  "item.minecraft.egg": "Telur",
  "item.minecraft.elder_guardian_spawn_egg": "Telur Pewujudan Tetua Penjaga",
  "item.minecraft.elytra": "Elitron",
  "item.minecraft.emerald": "Zamrud",
  "item.minecraft.enchanted_book": "Buku Pesona",
  "item.minecraft.enchanted_golden_apple": "Apel Emas Terpesona",
  "item.minecraft.end_crystal": "Kristal End",
  "item.minecraft.ender_dragon_spawn_egg": "Telur Pewujudan Naga Ender",
  "item.minecraft.ender_eye": "Mata Ender",
  "item.minecraft.ender_pearl": "Mutiara Ender",
  "item.minecraft.enderman_spawn_egg": "Telur Pewujudan Enderman",
  "item.minecraft.endermite_spawn_egg": "Telur Pewujudan Endermite",
  "item.minecraft.evoker_spawn_egg": "Telur Pewujudan Pawang",
  "item.minecraft.experience_bottle": "Botol Pesona",
  "item.minecraft.explorer_pottery_shard": "Serpihan Pasu Penjelajah",
  "item.minecraft.explorer_pottery_sherd": "Serpihan Pasu Penjelajah",
  "item.minecraft.eye_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Trim Zirah Mata",
  "item.minecraft.feather": "Bulu",
  "item.minecraft.fermented_spider_eye": "Mata Laba-Laba Beragi",
  "item.minecraft.field_masoned_banner_pattern": "Pola Panji Bataan",
  "item.minecraft.filled_map": "Peta",
  "item.minecraft.fire_charge": "Bola Api",
  "item.minecraft.firework_rocket": "Roket Kembang Api",
  "item.minecraft.firework_rocket.flight": "Durasi Terbang:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Bintang Kembang Api",
  "item.minecraft.firework_star.black": "Hitam",
  "item.minecraft.firework_star.blue": "Biru",
  "item.minecraft.firework_star.brown": "Cokelat",
  "item.minecraft.firework_star.custom_color": "Tersuai",
  "item.minecraft.firework_star.cyan": "Sian",
  "item.minecraft.firework_star.fade_to": "Pudar ke",
  "item.minecraft.firework_star.flicker": "Berkelip",
  "item.minecraft.firework_star.gray": "Abu-Abu",
  "item.minecraft.firework_star.green": "Hijau",
  "item.minecraft.firework_star.light_blue": "Biru Muda",
  "item.minecraft.firework_star.light_gray": "Abu-Abu Muda",
  "item.minecraft.firework_star.lime": "Hijau Pupus",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Jingga",
  "item.minecraft.firework_star.pink": "Merah Muda",
  "item.minecraft.firework_star.purple": "Ungu",
  "item.minecraft.firework_star.red": "Merah",
  "item.minecraft.firework_star.shape": "Bentuk Tidak Dikenal",
  "item.minecraft.firework_star.shape.burst": "Meledak",
  "item.minecraft.firework_star.shape.creeper": "Berbentuk Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola Besar",
  "item.minecraft.firework_star.shape.small_ball": "Bola Kecil",
  "item.minecraft.firework_star.shape.star": "Berbentuk Bintang",
  "item.minecraft.firework_star.trail": "Berjejak",
  "item.minecraft.firework_star.white": "Putih",
  "item.minecraft.firework_star.yellow": "Kuning",
  "item.minecraft.fishing_rod": "Pancing",
  "item.minecraft.flint": "Batu Api",
  "item.minecraft.flint_and_steel": "Pemantik Api",
  "item.minecraft.flow_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Trim Zirah Pilin",
  "item.minecraft.flow_banner_pattern": "Pola Panji",
  "item.minecraft.flow_banner_pattern.desc": "Pilin",
  "item.minecraft.flow_banner_pattern.new": "Pola Panji Pilin",
  "item.minecraft.flow_pottery_sherd": "Serpihan Pasu Pilin",
  "item.minecraft.flower_banner_pattern": "Pola Panji",
  "item.minecraft.flower_banner_pattern.desc": "Rupa Bunga",
  "item.minecraft.flower_banner_pattern.new": "Pola Panji Rupa Bunga",
  "item.minecraft.flower_pot": "Pot Bunga",
  "item.minecraft.fox_spawn_egg": "Telur Pewujudan Rubah",
  "item.minecraft.friend_pottery_shard": "Serpihan Pasu Teman",
  "item.minecraft.friend_pottery_sherd": "Serpihan Pasu Teman",
  "item.minecraft.frog_spawn_egg": "Telur Pewujudan Katak",
  "item.minecraft.furnace_minecart": "Kereta Tambang dengan Tungku",
  "item.minecraft.ghast_spawn_egg": "Telur Pewujudan Ghast",
  "item.minecraft.ghast_tear": "Air Mata Ghast",
  "item.minecraft.glass_bottle": "Botol Kaca",
  "item.minecraft.glistering_melon_slice": "Irisan Semangka Emas",
  "item.minecraft.globe_banner_pattern": "Pola Panji",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Pola Panji Globe",
  "item.minecraft.glow_berries": "Buni Sinar",
  "item.minecraft.glow_ink_sac": "Kantong Tinta Sinar",
  "item.minecraft.glow_item_frame": "Bingkai Benda Sinar",
  "item.minecraft.glow_squid_spawn_egg": "Telur Pewujudan Cumi-Cumi Sinar",
  "item.minecraft.glowstone_dust": "Serbuk Batu Sinar",
  "item.minecraft.goat_horn": "Tanduk Kambing",
  "item.minecraft.goat_spawn_egg": "Telur Pewujudan Kambing",
  "item.minecraft.gold_ingot": "Emas Batangan",
  "item.minecraft.gold_nugget": "Bongkahan Emas",
  "item.minecraft.golden_apple": "Apel Emas",
  "item.minecraft.golden_axe": "Kapak Emas",
  "item.minecraft.golden_boots": "Sepatu Emas",
  "item.minecraft.golden_carrot": "Wortel Emas",
  "item.minecraft.golden_chestplate": "Baju Emas",
  "item.minecraft.golden_helmet": "Helm Emas",
  "item.minecraft.golden_hoe": "Cangkul Emas",
  "item.minecraft.golden_horse_armor": "Zirah Kuda Emas",
  "item.minecraft.golden_leggings": "Celana Emas",
  "item.minecraft.golden_nautilus_armor": "Zirah Nautilus Emas",
  "item.minecraft.golden_pickaxe": "Beliung Emas",
  "item.minecraft.golden_shovel": "Sekop Emas",
  "item.minecraft.golden_spear": "Tombak Emas",
  "item.minecraft.golden_sword": "Pedang Emas",
  "item.minecraft.gray_bundle": "Kantong Abu-Abu",
  "item.minecraft.gray_dye": "Pewarna Abu-Abu",
  "item.minecraft.gray_harness": "Rungkup Abu-Abu",
  "item.minecraft.green_bundle": "Kantong Hijau",
  "item.minecraft.green_dye": "Pewarna Hijau",
  "item.minecraft.green_harness": "Rungkup Hijau",
  "item.minecraft.guardian_spawn_egg": "Telur Pewujudan Penjaga",
  "item.minecraft.gunpowder": "Bubuk Mesiu",
  "item.minecraft.guster_banner_pattern": "Pola Panji",
  "item.minecraft.guster_banner_pattern.desc": "Prahara",
  "item.minecraft.guster_banner_pattern.new": "Pola Panji Prahara",
  "item.minecraft.guster_pottery_sherd": "Serpihan Pasu Prahara",
  "item.minecraft.happy_ghast_spawn_egg": "Telur Pewujudan Ghast Riang",
  "item.minecraft.harness": "Rungkup",
  "item.minecraft.heart_of_the_sea": "Jantung Lautan",
  "item.minecraft.heart_pottery_shard": "Serpihan Pasu Hati",
  "item.minecraft.heart_pottery_sherd": "Serpihan Pasu Hati",
  "item.minecraft.heartbreak_pottery_shard": "Serpihan Pasu Patah Hati",
  "item.minecraft.heartbreak_pottery_sherd": "Serpihan Pasu Patah Hati",
  "item.minecraft.hoglin_spawn_egg": "Telur Pewujudan Hoglin",
  "item.minecraft.honey_bottle": "Botol Madu",
  "item.minecraft.honeycomb": "Sarang Madu",
  "item.minecraft.hopper_minecart": "Kereta Tambang dengan Corong",
  "item.minecraft.horse_spawn_egg": "Telur Pewujudan Kuda",
  "item.minecraft.host_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.host_armor_trim_smithing_template.new": "Trim Zirah Tuan Rumah",
  "item.minecraft.howl_pottery_shard": "Serpihan Pasu Lolong",
  "item.minecraft.howl_pottery_sherd": "Serpihan Pasu Lolong",
  "item.minecraft.husk_spawn_egg": "Telur Pewujudan Belulang",
  "item.minecraft.ink_sac": "Kantong Tinta",
  "item.minecraft.iron_axe": "Kapak Besi",
  "item.minecraft.iron_boots": "Sepatu Besi",
  "item.minecraft.iron_chestplate": "Baju Besi",
  "item.minecraft.iron_golem_spawn_egg": "Telur Pewujudan Golem Besi",
  "item.minecraft.iron_helmet": "Helm Besi",
  "item.minecraft.iron_hoe": "Cangkul Besi",
  "item.minecraft.iron_horse_armor": "Zirah Kuda Besi",
  "item.minecraft.iron_ingot": "Besi Batangan",
  "item.minecraft.iron_leggings": "Celana Besi",
  "item.minecraft.iron_nautilus_armor": "Zirah Nautilus Besi",
  "item.minecraft.iron_nugget": "Bongkahan Besi",
  "item.minecraft.iron_pickaxe": "Beliung Besi",
  "item.minecraft.iron_shovel": "Sekop Besi",
  "item.minecraft.iron_spear": "Tombak Besi",
  "item.minecraft.iron_sword": "Pedang Besi",
  "item.minecraft.item_frame": "Bingkai Benda",
  "item.minecraft.jungle_boat": "Perahu Rimba",
  "item.minecraft.jungle_chest_boat": "Perahu Rimba dengan Peti",
  "item.minecraft.knowledge_book": "Buku Pengetahuan",
  "item.minecraft.lapis_lazuli": "Lazuardi",
  "item.minecraft.lava_bucket": "Ember Lava",
  "item.minecraft.lead": "Tali Pengikat",
  "item.minecraft.leather": "Kulit",
  "item.minecraft.leather_boots": "Sepatu Kulit",
  "item.minecraft.leather_chestplate": "Baju Kulit",
  "item.minecraft.leather_helmet": "Topi Kulit",
  "item.minecraft.leather_horse_armor": "Zirah Kuda Kulit",
  "item.minecraft.leather_leggings": "Celana Kulit",
  "item.minecraft.light_blue_bundle": "Kantong Biru Muda",
  "item.minecraft.light_blue_dye": "Pewarna Biru Muda",
  "item.minecraft.light_blue_harness": "Rungkup Biru Muda",
  "item.minecraft.light_gray_bundle": "Kantong Abu-Abu Muda",
  "item.minecraft.light_gray_dye": "Pewarna Abu-Abu Muda",
  "item.minecraft.light_gray_harness": "Rungkup Abu-Abu Muda",
  "item.minecraft.lime_bundle": "Kantong Hijau Pupus",
  "item.minecraft.lime_dye": "Pewarna Hijau Pupus",
  "item.minecraft.lime_harness": "Rungkup Hijau Pupus",
  "item.minecraft.lingering_potion": "Ramuan Bertahan",
  "item.minecraft.lingering_potion.effect.awkward": "Ramuan Bertahan Kikuk",
  "item.minecraft.lingering_potion.effect.empty": "Ramuan Bertahan Nirracik",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Ramuan Bertahan Tahan Api",
  "item.minecraft.lingering_potion.effect.harming": "Ramuan Bertahan Kesakitan",
  "item.minecraft.lingering_potion.effect.healing": "Ramuan Bertahan Penyembuhan",
  "item.minecraft.lingering_potion.effect.infested": "Ramuan Bertahan Infestasi",
  "item.minecraft.lingering_potion.effect.invisibility": "Ramuan Bertahan Halimunan",
  "item.minecraft.lingering_potion.effect.leaping": "Ramuan Bertahan Lompatan",
  "item.minecraft.lingering_potion.effect.levitation": "Ramuan Bertahan Pelayangan",
  "item.minecraft.lingering_potion.effect.luck": "Ramuan Bertahan Keberuntungan",
  "item.minecraft.lingering_potion.effect.mundane": "Ramuan Bertahan Tumpul",
  "item.minecraft.lingering_potion.effect.night_vision": "Ramuan Bertahan Penglihatan Gelap",
  "item.minecraft.lingering_potion.effect.oozing": "Ramuan Bertahan Pencucuran",
  "item.minecraft.lingering_potion.effect.poison": "Ramuan Bertahan Racun",
  "item.minecraft.lingering_potion.effect.regeneration": "Ramuan Bertahan Regenerasi",
  "item.minecraft.lingering_potion.effect.slow_falling": "Ramuan Bertahan Tumbang Lambat",
  "item.minecraft.lingering_potion.effect.slowness": "Ramuan Bertahan Kelambatan",
  "item.minecraft.lingering_potion.effect.strength": "Ramuan Bertahan Kekuatan",
  "item.minecraft.lingering_potion.effect.swiftness": "Ramuan Bertahan Kecepatan",
  "item.minecraft.lingering_potion.effect.thick": "Ramuan Bertahan Kental",
  "item.minecraft.lingering_potion.effect.turtle_master": "Ramuan Bertahan Guru Penyu",
  "item.minecraft.lingering_potion.effect.water": "Botol Air Bertahan",
  "item.minecraft.lingering_potion.effect.water_breathing": "Ramuan Bertahan Pernapasan Air",
  "item.minecraft.lingering_potion.effect.weakness": "Ramuan Bertahan Kelemahan",
  "item.minecraft.lingering_potion.effect.weaving": "Ramuan Bertahan Merajut",
  "item.minecraft.lingering_potion.effect.wind_charged": "Ramuan Bertahan Embusan",
  "item.minecraft.llama_spawn_egg": "Telur Pewujudan Lama",
  "item.minecraft.lodestone_compass": "Kompas Batu Magnet",
  "item.minecraft.mace": "Gada",
  "item.minecraft.magenta_bundle": "Kantong Magenta",
  "item.minecraft.magenta_dye": "Pewarna Magenta",
  "item.minecraft.magenta_harness": "Rungkup Magenta",
  "item.minecraft.magma_cream": "Krim Magma",
  "item.minecraft.magma_cube_spawn_egg": "Telur Pewujudan Kubus Magma",
  "item.minecraft.mangrove_boat": "Perahu Bakau",
  "item.minecraft.mangrove_chest_boat": "Perahu Bakau dengan Peti",
  "item.minecraft.map": "Peta Kosong",
  "item.minecraft.melon_seeds": "Benih Semangka",
  "item.minecraft.melon_slice": "Irisan Semangka",
  "item.minecraft.milk_bucket": "Ember Susu",
  "item.minecraft.minecart": "Kereta Tambang",
  "item.minecraft.miner_pottery_shard": "Serpihan Pasu Penambang",
  "item.minecraft.miner_pottery_sherd": "Serpihan Pasu Penambang",
  "item.minecraft.mojang_banner_pattern": "Pola Panji",
  "item.minecraft.mojang_banner_pattern.desc": "Lambang",
  "item.minecraft.mojang_banner_pattern.new": "Pola Panji Lambang",
  "item.minecraft.mooshroom_spawn_egg": "Telur Pewujudan Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Serpihan Pasu Duka",
  "item.minecraft.mourner_pottery_sherd": "Serpihan Pasu Duka",
  "item.minecraft.mule_spawn_egg": "Telur Pewujudan Bagal",
  "item.minecraft.mushroom_stew": "Sup Jamur",
  "item.minecraft.music_disc_11": "Cakram Musik",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Cakram Musik",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Cakram Musik",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Cakram Musik",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Cakram Musik",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Cakram Musik",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Cakram Musik",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Cakram Musik",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Kotak Musik)",
  "item.minecraft.music_disc_far": "Cakram Musik",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Cakram Musik",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Cakram Musik",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Cakram Musik",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Cakram Musik",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Cakram Musik",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Cakram Musik",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Cakram Musik",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Cakram Musik",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Cakram Musik",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Cakram Musik",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Cakram Musik",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Cakram Musik",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Daging Domba Mentah",
  "item.minecraft.name_tag": "Label Nama",
  "item.minecraft.nautilus_shell": "Cangkang Nautilus",
  "item.minecraft.nautilus_spawn_egg": "Telur Pewujudan Nautilus",
  "item.minecraft.nether_brick": "Bata Nether",
  "item.minecraft.nether_star": "Bintang Nether",
  "item.minecraft.nether_wart": "Ketuat Nether",
  "item.minecraft.netherite_axe": "Kapak Netherit",
  "item.minecraft.netherite_boots": "Sepatu Netherit",
  "item.minecraft.netherite_chestplate": "Baju Netherit",
  "item.minecraft.netherite_helmet": "Helm Netherit",
  "item.minecraft.netherite_hoe": "Cangkul Netherit",
  "item.minecraft.netherite_horse_armor": "Zirah Kuda Netherit",
  "item.minecraft.netherite_ingot": "Netherit Batangan",
  "item.minecraft.netherite_leggings": "Celana Netherit",
  "item.minecraft.netherite_nautilus_armor": "Zirah Nautilus Netherit",
  "item.minecraft.netherite_pickaxe": "Beliung Netherit",
  "item.minecraft.netherite_scrap": "Kepingan Netherit",
  "item.minecraft.netherite_shovel": "Sekop Netherit",
  "item.minecraft.netherite_spear": "Tombak Netherit",
  "item.minecraft.netherite_sword": "Pedang Netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Templat Tempa",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Peningkatan Netherit",
  "item.minecraft.oak_boat": "Perahu Ek",
  "item.minecraft.oak_chest_boat": "Perahu Ek dengan Peti",
  "item.minecraft.ocelot_spawn_egg": "Telur Pewujudan Oselot",
  "item.minecraft.ominous_bottle": "Botol Mengerikan",
  "item.minecraft.ominous_trial_key": "Kunci Cobaan Mengerikan",
  "item.minecraft.orange_bundle": "Kantong Jingga",
  "item.minecraft.orange_dye": "Pewarna Jingga",
  "item.minecraft.orange_harness": "Rungkup Jingga",
  "item.minecraft.painting": "Lukisan",
  "item.minecraft.pale_oak_boat": "Perahu Ek Pucat",
  "item.minecraft.pale_oak_chest_boat": "Perahu Ek Pucat dengan Peti",
  "item.minecraft.panda_spawn_egg": "Telur Pewujudan Panda",
  "item.minecraft.paper": "Kertas",
  "item.minecraft.parched_spawn_egg": "Telur Pewujudan Kerontang",
  "item.minecraft.parrot_spawn_egg": "Telur Pewujudan Bayan",
  "item.minecraft.phantom_membrane": "Selaput Angan-Angan",
  "item.minecraft.phantom_spawn_egg": "Telur Pewujudan Angan-Angan",
  "item.minecraft.pig_spawn_egg": "Telur Pewujudan Babi",
  "item.minecraft.piglin_banner_pattern": "Pola Panji",
  "item.minecraft.piglin_banner_pattern.desc": "Moncong",
  "item.minecraft.piglin_banner_pattern.new": "Pola Panji Moncong",
  "item.minecraft.piglin_brute_spawn_egg": "Telur Pewujudan Piglin Ganas",
  "item.minecraft.piglin_spawn_egg": "Telur Pewujudan Piglin",
  "item.minecraft.pillager_spawn_egg": "Telur Pewujudan Penjarah",
  "item.minecraft.pink_bundle": "Kantong Merah Muda",
  "item.minecraft.pink_dye": "Pewarna Merah Muda",
  "item.minecraft.pink_harness": "Rungkup Merah Muda",
  "item.minecraft.pitcher_plant": "Kantong Semar",
  "item.minecraft.pitcher_pod": "Polong Kantong Semar",
  "item.minecraft.plenty_pottery_shard": "Serpihan Pasu Kelimpahan",
  "item.minecraft.plenty_pottery_sherd": "Serpihan Pasu Kelimpahan",
  "item.minecraft.poisonous_potato": "Kentang Beracun",
  "item.minecraft.polar_bear_spawn_egg": "Telur Pewujudan Beruang Kutub",
  "item.minecraft.popped_chorus_fruit": "Buah Korus Bakar",
  "item.minecraft.porkchop": "Daging Babi Mentah",
  "item.minecraft.potato": "Kentang",
  "item.minecraft.potion": "Ramuan",
  "item.minecraft.potion.effect.awkward": "Ramuan Kikuk",
  "item.minecraft.potion.effect.empty": "Ramuan Nirracik",
  "item.minecraft.potion.effect.fire_resistance": "Ramuan Tahan Api",
  "item.minecraft.potion.effect.harming": "Ramuan Kesakitan",
  "item.minecraft.potion.effect.healing": "Ramuan Penyembuhan",
  "item.minecraft.potion.effect.infested": "Ramuan Infestasi",
  "item.minecraft.potion.effect.invisibility": "Ramuan Halimunan",
  "item.minecraft.potion.effect.leaping": "Ramuan Lompatan",
  "item.minecraft.potion.effect.levitation": "Ramuan Pelayangan",
  "item.minecraft.potion.effect.luck": "Ramuan Keberuntungan",
  "item.minecraft.potion.effect.mundane": "Ramuan Tumpul",
  "item.minecraft.potion.effect.night_vision": "Ramuan Penglihatan Gelap",
  "item.minecraft.potion.effect.oozing": "Ramuan Pencucuran",
  "item.minecraft.potion.effect.poison": "Ramuan Racun",
  "item.minecraft.potion.effect.regeneration": "Ramuan Regenerasi",
  "item.minecraft.potion.effect.slow_falling": "Ramuan Tumbang Lambat",
  "item.minecraft.potion.effect.slowness": "Ramuan Kelambatan",
  "item.minecraft.potion.effect.strength": "Ramuan Kekuatan",
  "item.minecraft.potion.effect.swiftness": "Ramuan Kecepatan",
  "item.minecraft.potion.effect.thick": "Ramuan Kental",
  "item.minecraft.potion.effect.turtle_master": "Ramuan Guru Penyu",
  "item.minecraft.potion.effect.water": "Botol Air",
  "item.minecraft.potion.effect.water_breathing": "Ramuan Pernapasan Air",
  "item.minecraft.potion.effect.weakness": "Ramuan Kelemahan",
  "item.minecraft.potion.effect.weaving": "Ramuan Merajut",
  "item.minecraft.potion.effect.wind_charged": "Ramuan Embusan",
  "item.minecraft.pottery_shard_archer": "Serpihan Pasu Pemanah",
  "item.minecraft.pottery_shard_arms_up": "Serpihan Pasu Angkat Tangan",
  "item.minecraft.pottery_shard_prize": "Serpihan Pasu Hadiah",
  "item.minecraft.pottery_shard_skull": "Serpihan Pasu Tengkorak",
  "item.minecraft.powder_snow_bucket": "Ember Salju Bubuk",
  "item.minecraft.prismarine_crystals": "Kristal Prismarine",
  "item.minecraft.prismarine_shard": "Serpihan Prismarine",
  "item.minecraft.prize_pottery_shard": "Serpihan Pasu Hadiah",
  "item.minecraft.prize_pottery_sherd": "Serpihan Pasu Hadiah",
  "item.minecraft.pufferfish": "Ikan Buntal",
  "item.minecraft.pufferfish_bucket": "Ember Ikan Buntal",
  "item.minecraft.pufferfish_spawn_egg": "Telur Pewujudan Ikan Buntal",
  "item.minecraft.pumpkin_pie": "Pai Labu",
  "item.minecraft.pumpkin_seeds": "Benih Labu",
  "item.minecraft.purple_bundle": "Kantong Ungu",
  "item.minecraft.purple_dye": "Pewarna Ungu",
  "item.minecraft.purple_harness": "Rungkup Ungu",
  "item.minecraft.quartz": "Kuarsa Nether",
  "item.minecraft.rabbit": "Daging Kelinci Mentah",
  "item.minecraft.rabbit_foot": "Kaki Kelinci",
  "item.minecraft.rabbit_hide": "Kulit Kelinci",
  "item.minecraft.rabbit_spawn_egg": "Telur Pewujudan Kelinci",
  "item.minecraft.rabbit_stew": "Sup Kelinci",
  "item.minecraft.raiser_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Trim Zirah Pemelihara",
  "item.minecraft.ravager_spawn_egg": "Telur Pewujudan Pembinasa",
  "item.minecraft.raw_copper": "Tembaga Mentah",
  "item.minecraft.raw_gold": "Emas Mentah",
  "item.minecraft.raw_iron": "Besi Mentah",
  "item.minecraft.recovery_compass": "Kompas Pemulihan",
  "item.minecraft.red_bundle": "Kantong Merah",
  "item.minecraft.red_dye": "Pewarna Merah",
  "item.minecraft.red_harness": "Rungkup Merah",
  "item.minecraft.redstone": "Serbuk Redstone",
  "item.minecraft.resin_brick": "Bata Resin",
  "item.minecraft.resin_clump": "Gumpalan Resin",
  "item.minecraft.rib_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Trim Zirah Rusuk",
  "item.minecraft.rotten_flesh": "Daging Busuk",
  "item.minecraft.saddle": "Pelana",
  "item.minecraft.salmon": "Salmon Mentah",
  "item.minecraft.salmon_bucket": "Ember Salmon",
  "item.minecraft.salmon_spawn_egg": "Telur Pewujudan Salmon",
  "item.minecraft.scrape_pottery_sherd": "Serpihan Pasu Kikis",
  "item.minecraft.scute": "Skutum",
  "item.minecraft.sentry_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Trim Zirah Pengawal",
  "item.minecraft.shaper_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Trim Zirah Pembentuk",
  "item.minecraft.sheaf_pottery_shard": "Serpihan Pasu Berkas",
  "item.minecraft.sheaf_pottery_sherd": "Serpihan Pasu Berkas",
  "item.minecraft.shears": "Gunting",
  "item.minecraft.sheep_spawn_egg": "Telur Pewujudan Domba",
  "item.minecraft.shelter_pottery_shard": "Serpihan Pasu Naungan",
  "item.minecraft.shelter_pottery_sherd": "Serpihan Pasu Naungan",
  "item.minecraft.shield": "Perisai",
  "item.minecraft.shield.black": "Perisai Hitam",
  "item.minecraft.shield.blue": "Perisai Biru",
  "item.minecraft.shield.brown": "Perisai Cokelat",
  "item.minecraft.shield.cyan": "Perisai Sian",
  "item.minecraft.shield.gray": "Perisai Abu-Abu",
  "item.minecraft.shield.green": "Perisai Hijau",
  "item.minecraft.shield.light_blue": "Perisai Biru Muda",
  "item.minecraft.shield.light_gray": "Perisai Abu-Abu Muda",
  "item.minecraft.shield.lime": "Perisai Hijau Pupus",
  "item.minecraft.shield.magenta": "Perisai Magenta",
  "item.minecraft.shield.orange": "Perisai Jingga",
  "item.minecraft.shield.pink": "Perisai Merah Muda",
  "item.minecraft.shield.purple": "Perisai Ungu",
  "item.minecraft.shield.red": "Perisai Merah",
  "item.minecraft.shield.white": "Perisai Putih",
  "item.minecraft.shield.yellow": "Perisai Kuning",
  "item.minecraft.shulker_shell": "Cangkang Shulker",
  "item.minecraft.shulker_spawn_egg": "Telur Pewujudan Shulker",
  "item.minecraft.sign": "Papan Tanda",
  "item.minecraft.silence_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Trim Zirah Keheningan",
  "item.minecraft.silverfish_spawn_egg": "Telur Pewujudan Gegat",
  "item.minecraft.skeleton_horse_spawn_egg": "Telur Pewujudan Kuda Bengkarak",
  "item.minecraft.skeleton_spawn_egg": "Telur Pewujudan Bengkarak",
  "item.minecraft.skull_banner_pattern": "Pola Panji",
  "item.minecraft.skull_banner_pattern.desc": "Rupa Tengkorak",
  "item.minecraft.skull_banner_pattern.new": "Pola Panji Rupa Tengkorak",
  "item.minecraft.skull_pottery_shard": "Serpihan Pasu Tengkorak",
  "item.minecraft.skull_pottery_sherd": "Serpihan Pasu Tengkorak",
  "item.minecraft.slime_ball": "Bola Geladir",
  "item.minecraft.slime_spawn_egg": "Telur Pewujudan Geladir",
  "item.minecraft.smithing_template": "Templat Tempa",
  "item.minecraft.smithing_template.applies_to": "Diterapkan pada:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Tambah batangan atau kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Zirah",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Tambah sepotong zirah",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Batangan & Kristal",
  "item.minecraft.smithing_template.ingredients": "Bahan:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Tambah Netherit Batangan",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Peralatan Berlian",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Tambah zirah, senjata, atau alat berlian",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherit Batangan",
  "item.minecraft.smithing_template.upgrade": "Tingkatan: ",
  "item.minecraft.sniffer_spawn_egg": "Telur Pewujudan Pengendus",
  "item.minecraft.snort_pottery_shard": "Serpihan Pasu Dengus",
  "item.minecraft.snort_pottery_sherd": "Serpihan Pasu Dengus",
  "item.minecraft.snout_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Trim Zirah Moncong",
  "item.minecraft.snow_golem_spawn_egg": "Telur Pewujudan Golem Salju",
  "item.minecraft.snowball": "Bola Salju",
  "item.minecraft.spectral_arrow": "Panah Bersinar",
  "item.minecraft.spider_eye": "Mata Laba-Laba",
  "item.minecraft.spider_spawn_egg": "Telur Pewujudan Laba-Laba",
  "item.minecraft.spire_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Trim Zirah Menara",
  "item.minecraft.splash_potion": "Ramuan Ciprat",
  "item.minecraft.splash_potion.effect.awkward": "Ramuan Ciprat Kikuk",
  "item.minecraft.splash_potion.effect.empty": "Ramuan Ciprat Nirracik",
  "item.minecraft.splash_potion.effect.fire_resistance": "Ramuan Ciprat Tahan Api",
  "item.minecraft.splash_potion.effect.harming": "Ramuan Ciprat Kesakitan",
  "item.minecraft.splash_potion.effect.healing": "Ramuan Ciprat Penyembuhan",
  "item.minecraft.splash_potion.effect.infested": "Ramuan Ciprat Infestasi",
  "item.minecraft.splash_potion.effect.invisibility": "Ramuan Ciprat Halimunan",
  "item.minecraft.splash_potion.effect.leaping": "Ramuan Ciprat Lompatan",
  "item.minecraft.splash_potion.effect.levitation": "Ramuan Ciprat Pelayangan",
  "item.minecraft.splash_potion.effect.luck": "Ramuan Ciprat Keberuntungan",
  "item.minecraft.splash_potion.effect.mundane": "Ramuan Ciprat Tumpul",
  "item.minecraft.splash_potion.effect.night_vision": "Ramuan Ciprat Penglihatan Gelap",
  "item.minecraft.splash_potion.effect.oozing": "Ramuan Ciprat Pencucuran",
  "item.minecraft.splash_potion.effect.poison": "Ramuan Ciprat Racun",
  "item.minecraft.splash_potion.effect.regeneration": "Ramuan Ciprat Regenerasi",
  "item.minecraft.splash_potion.effect.slow_falling": "Ramuan Ciprat Tumbang Lambat",
  "item.minecraft.splash_potion.effect.slowness": "Ramuan Ciprat Kelambatan",
  "item.minecraft.splash_potion.effect.strength": "Ramuan Ciprat Kekuatan",
  "item.minecraft.splash_potion.effect.swiftness": "Ramuan Ciprat Kecepatan",
  "item.minecraft.splash_potion.effect.thick": "Ramuan Ciprat Kental",
  "item.minecraft.splash_potion.effect.turtle_master": "Ramuan Ciprat Guru Penyu",
  "item.minecraft.splash_potion.effect.water": "Botol Air Ciprat",
  "item.minecraft.splash_potion.effect.water_breathing": "Ramuan Ciprat Pernapasan Air",
  "item.minecraft.splash_potion.effect.weakness": "Ramuan Ciprat Kelemahan",
  "item.minecraft.splash_potion.effect.weaving": "Ramuan Ciprat Merajut",
  "item.minecraft.splash_potion.effect.wind_charged": "Ramuaun Ciprat Embusan",
  "item.minecraft.spruce_boat": "Perahu Kayu Cemara",
  "item.minecraft.spruce_chest_boat": "Perahu Cemara dengan Peti",
  "item.minecraft.spyglass": "Teropong",
  "item.minecraft.squid_spawn_egg": "Telur Pewujudan Cumi-Cumi",
  "item.minecraft.stick": "Batang Kayu",
  "item.minecraft.stone_axe": "Kapak Batu",
  "item.minecraft.stone_hoe": "Cangkul Batu",
  "item.minecraft.stone_pickaxe": "Beliung Batu",
  "item.minecraft.stone_shovel": "Sekop Batu",
  "item.minecraft.stone_spear": "Tombak Batu",
  "item.minecraft.stone_sword": "Pedang Batu",
  "item.minecraft.stray_spawn_egg": "Telur Pewujudan Tualang",
  "item.minecraft.strider_spawn_egg": "Telur Pewujudan Pengarung",
  "item.minecraft.string": "Benang",
  "item.minecraft.sugar": "Gula",
  "item.minecraft.suspicious_stew": "Sup Mencurigakan",
  "item.minecraft.sweet_berries": "Beri Manis",
  "item.minecraft.tadpole_bucket": "Ember Kecebong",
  "item.minecraft.tadpole_spawn_egg": "Telur Pewujudan Kecebong",
  "item.minecraft.tide_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Trim Zirah Gelombang Pasang",
  "item.minecraft.tipped_arrow": "Panah Celupan",
  "item.minecraft.tipped_arrow.effect.awkward": "Panah Celupan",
  "item.minecraft.tipped_arrow.effect.empty": "Panah Celupan Nirracik",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Panah Tahan Api",
  "item.minecraft.tipped_arrow.effect.harming": "Panah Kesakitan",
  "item.minecraft.tipped_arrow.effect.healing": "Panah Penyembuhan",
  "item.minecraft.tipped_arrow.effect.infested": "Panah Infestasi",
  "item.minecraft.tipped_arrow.effect.invisibility": "Panah Halimunan",
  "item.minecraft.tipped_arrow.effect.leaping": "Panah Lompatan",
  "item.minecraft.tipped_arrow.effect.levitation": "Panah Pelayangan",
  "item.minecraft.tipped_arrow.effect.luck": "Panah Keberuntungan",
  "item.minecraft.tipped_arrow.effect.mundane": "Panah Celupan",
  "item.minecraft.tipped_arrow.effect.night_vision": "Panah Penglihatan Gelap",
  "item.minecraft.tipped_arrow.effect.oozing": "Panah Pencucuran",
  "item.minecraft.tipped_arrow.effect.poison": "Panah Racun",
  "item.minecraft.tipped_arrow.effect.regeneration": "Panah Regenerasi",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Panah Tumbang Lambat",
  "item.minecraft.tipped_arrow.effect.slowness": "Panah Kelambatan",
  "item.minecraft.tipped_arrow.effect.strength": "Panah Kekuatan",
  "item.minecraft.tipped_arrow.effect.swiftness": "Panah Kecepatan",
  "item.minecraft.tipped_arrow.effect.thick": "Panah Celupan",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Panah Guru Penyu",
  "item.minecraft.tipped_arrow.effect.water": "Panah Ciprat",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Panah Pernapasan Air",
  "item.minecraft.tipped_arrow.effect.weakness": "Panah Kelemahan",
  "item.minecraft.tipped_arrow.effect.weaving": "Panah Merajut",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Panah Embusan",
  "item.minecraft.tnt_minecart": "Kereta Tambang dengan TNT",
  "item.minecraft.torchflower_seeds": "Benih Bunga Obor",
  "item.minecraft.totem_of_undying": "Azimat Keabadian",
  "item.minecraft.trader_llama_spawn_egg": "Telur Pewujudan Lama Pedagang",
  "item.minecraft.trial_key": "Kunci Cobaan",
  "item.minecraft.trident": "Trisula",
  "item.minecraft.tropical_fish": "Ikan Tropis",
  "item.minecraft.tropical_fish_bucket": "Ember Ikan Tropis",
  "item.minecraft.tropical_fish_spawn_egg": "Telur Pewujudan Ikan Tropis",
  "item.minecraft.turtle_helmet": "Cangkang Penyu",
  "item.minecraft.turtle_scute": "Skutum Penyu",
  "item.minecraft.turtle_spawn_egg": "Telur Pewujudan Penyu",
  "item.minecraft.vex_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Trim Zirah Usik",
  "item.minecraft.vex_spawn_egg": "Telur Pewujudan Tuyul",
  "item.minecraft.villager_spawn_egg": "Telur Pewujudan Penduduk",
  "item.minecraft.vindicator_spawn_egg": "Telur Pewujudan Pembela",
  "item.minecraft.wandering_trader_spawn_egg": "Telur Pewujudan Pedagang Keliling",
  "item.minecraft.ward_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Trim Zirah Jaga",
  "item.minecraft.warden_spawn_egg": "Telur Pewujudan Penunggu",
  "item.minecraft.warped_fungus_on_a_stick": "Jamur Kerukut di Tongkat",
  "item.minecraft.water_bucket": "Ember Air",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Trim Zirah Pandu",
  "item.minecraft.wheat": "Gandum",
  "item.minecraft.wheat_seeds": "Benih Gandum",
  "item.minecraft.white_bundle": "Kantong Putih",
  "item.minecraft.white_dye": "Pewarna Putih",
  "item.minecraft.white_harness": "Rungkup Putih",
  "item.minecraft.wild_armor_trim_smithing_template": "Templat Tempa",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Trim Zirah Liar",
  "item.minecraft.wind_charge": "Bola Angin",
  "item.minecraft.witch_spawn_egg": "Telur Pewujudan Penyihir",
  "item.minecraft.wither_skeleton_spawn_egg": "Telur Pewujudan Bengkarak Wither",
  "item.minecraft.wither_spawn_egg": "Telur Pewujudan Wither",
  "item.minecraft.wolf_armor": "Zirah Serigala",
  "item.minecraft.wolf_spawn_egg": "Telur Pewujudan Serigala",
  "item.minecraft.wooden_axe": "Kapak Kayu",
  "item.minecraft.wooden_hoe": "Cangkul Kayu",
  "item.minecraft.wooden_pickaxe": "Beliung Kayu",
  "item.minecraft.wooden_shovel": "Sekop Kayu",
  "item.minecraft.wooden_spear": "Tombak Kayu",
  "item.minecraft.wooden_sword": "Pedang Kayu",
  "item.minecraft.writable_book": "Buku dan Pena",
  "item.minecraft.written_book": "Buku Tertulis",
  "item.minecraft.yellow_bundle": "Kantong Kuning",
  "item.minecraft.yellow_dye": "Pewarna Kuning",
  "item.minecraft.yellow_harness": "Rungkup Kuning",
  "item.minecraft.zoglin_spawn_egg": "Telur Pewujudan Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Telur Pewujudan Kuda Zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Telur Pewujudan Nautilus Zombi",
  "item.minecraft.zombie_spawn_egg": "Telur Pewujudan Zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Telur Pewujudan Penduduk Zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Telur Pewujudan Piglin Zombi"
}
export const id_id = items; 
